// import React, { useState, useEffect } from "react";

// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Chip,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Paper,
//   Grid,
//   Card,
//   CardContent,
//   Alert,
//   CircularProgress,
//   AppBar,
//   Toolbar,
//   Fab,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   TableSortLabel,
//   TableContainer,
// } from "@mui/material";
// import {
//   Add as AddIcon,
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   Visibility as ViewIcon,
//   Close as CloseIcon,
//   Pets as PetsIcon,
//   FilterList as FilterIcon,
//   Search as SearchIcon,
// } from "@mui/icons-material";
// import { TableVirtuoso } from "react-virtuoso";
// import { useNavigate } from "react-router-dom";
// import swal from "sweetalert";

// // Virtualized Table Components
// const VirtuosoTableComponents = {
//   Scroller: React.forwardRef((props, ref) => (
//     <TableContainer component={Paper} {...props} ref={ref} />
//   )),
//   Table: (props) => (
//     <Table
//       {...props}
//       sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
//     />
//   ),
//   TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
//   TableRow: (props) => <TableRow {...props} />,
//   TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
// };

// const DraftAnimalsPage = () => {
//   const navigate = useNavigate();
//   const [animals, setAnimals] = useState([]);
//   const [filteredAnimals, setFilteredAnimals] = useState([]);
//   const [loading, setLoading] = useState(false);
  
//   // Modals
//   const [addModalOpen, setAddModalOpen] = useState(false);
//   const [editModalOpen, setEditModalOpen] = useState(false);
  
//   // Filters and Search
//   const [searchTerm, setSearchTerm] = useState("");
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
//   const [filters, setFilters] = useState({
//     species: "",
//     breed: "",
//     sex: "",
//     animal_type: ""
//   });

//   const [showFilters, setShowFilters] = useState(false);

//   // Options and Form Data
//   const [options, setOptions] = useState({
//     species: [],
//     breeds: {},
//     sexes: [],
//     animal_classes: {},
//     lifecycle_states: [],
//     reproductive_statuses: [],
//     pregnancy_statuses: [],
//     milking_statuses: [],
//     semen_statuses: [],
//     health_statuses: []
//   });

//   const [form, setForm] = useState({
//     tag_number: "",
//     name: "",
//     species: "Cattle",
//     breed: "",
//     dob: "",
//     sex: "Female",
//     animal_class: "",
//     color: "",
//     lifecycle_state: "Draft",
//     animal_type: "born"
//   });

//   const [editingId, setEditingId] = useState(null);

//   const API_URL = "http://127.0.0.1:5055/api/animals";

//   // Custom color theme
//   const colors = {
//     amber: '#ffc107',
//     green: '#198754',
//     amberLight: '#ffecb3',
//     amberDark: '#ff8f00',
//     greenLight: '#4caf50',
//     greenDark: '#0d6e3d'
//   };

//   // Table Columns for Virtualized Table
//   const columns = [
//     { width: 120, label: 'Tag #', dataKey: 'tag_number' },
//     { width: 120, label: 'Name', dataKey: 'name' },
//     { width: 100, label: 'Species', dataKey: 'species' },
//     { width: 120, label: 'Breed', dataKey: 'breed' },
//     { width: 100, label: 'Type', dataKey: 'animal_type' },
//     { width: 80, label: 'Age', dataKey: 'age_string' },
//     { width: 80, label: 'Gender', dataKey: 'sex' },
//     { width: 100, label: 'Weight (kg)', dataKey: 'current_weight' },
//     { width: 120, label: 'Location', dataKey: 'location' },
//     { width: 100, label: 'Status', dataKey: 'lifecycle_state' },
//     { width: 180, label: 'Actions', dataKey: 'actions' },
//   ];

//   // Calculate age from DOB
//   const calculateAge = (dobString) => {
//     if (!dobString) return 'N/A';
    
//     try {
//       const dob = new Date(dobString);
//       const today = new Date();
//       let months = (today.getFullYear() - dob.getFullYear()) * 12;
//       months -= dob.getMonth();
//       months += today.getMonth();
      
//       if (months < 12) {
//         return `${months} month${months !== 1 ? 's' : ''}`;
//       } else {
//         const years = Math.floor(months / 12);
//         const remainingMonths = months % 12;
//         if (remainingMonths === 0) {
//           return `${years} year${years !== 1 ? 's' : ''}`;
//         }
//         return `${years}y ${remainingMonths}m`;
//       }
//     } catch (error) {
//       return 'N/A';
//     }
//   };

//   // Enhanced animal data processing
//   const processAnimalData = (animal) => {
//     return {
//       ...animal,
//       age_string: calculateAge(animal.dob),
//       animal_type: animal.purchase_price ? "purchased" : "born"
//     };
//   };

//   // Fetch Options
//   const fetchOptions = async () => {
//     try {
//       const res = await fetch(`${API_URL}/options`);
//       const data = await res.json();
//       if (res.ok) {
//         setOptions(data);
//       } else {
//         console.error('Failed to fetch options:', data.error);
//       }
//     } catch (err) {
//       console.error('Error fetching options:', err);
//       swal("Error", "Failed to load form options", "error");
//     }
//   };

//   // Fetch Draft Animals
//   const fetchAnimals = async () => {
//     setLoading(true);
//     try {
//       const queryParams = new URLSearchParams();
//       Object.entries(filters).forEach(([key, value]) => {
//         if (value) queryParams.append(key, value);
//       });
//       queryParams.append('lifecycle_state', 'Draft');

//       const url = `${API_URL}?${queryParams.toString()}`;
//       const res = await fetch(url);
      
//       if (!res.ok) {
//         throw new Error(`HTTP error! status: ${res.status}`);
//       }
      
//       const data = await res.json();
      
//       let animalsArray = [];
//       if (data.animals && Array.isArray(data.animals)) {
//         animalsArray = data.animals.map(processAnimalData);
//       } else if (Array.isArray(data)) {
//         animalsArray = data.map(processAnimalData);
//       }
      
//       setAnimals(animalsArray);
//     } catch (err) {
//       console.error('Error fetching draft animals:', err);
//       swal("Error", "Failed to fetch draft animals", "error");
//       setAnimals([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchOptions();
//   }, []);

//   useEffect(() => {
//     fetchAnimals();
//   }, [filters]);

//   // Filter animals based on search
//   useEffect(() => {
//     if (!Array.isArray(animals)) {
//       setFilteredAnimals([]);
//       return;
//     }
    
//     let results = animals;

//     // Apply search term
//     if (searchTerm) {
//       const searchLower = searchTerm.toLowerCase();
//       results = results.filter(animal =>
//         (animal.tag_number?.toLowerCase() || '').includes(searchLower) ||
//         (animal.name?.toLowerCase() || '').includes(searchLower) ||
//         (animal.breed?.toLowerCase() || '').includes(searchLower) ||
//         (animal.herd_id?.toLowerCase() || '').includes(searchLower) ||
//         (animal.location?.toLowerCase() || '').includes(searchLower)
//       );
//     }

//     // Apply sorting
//     if (sortConfig.key) {
//       results.sort((a, b) => {
//         let aVal = a[sortConfig.key];
//         let bVal = b[sortConfig.key];
        
//         // Handle null/undefined values
//         if (aVal == null) return sortConfig.direction === 'asc' ? 1 : -1;
//         if (bVal == null) return sortConfig.direction === 'asc' ? -1 : 1;
        
//         // Handle numeric values
//         if (typeof aVal === 'number' && typeof bVal === 'number') {
//           return sortConfig.direction === 'asc' ? aVal - bVal : bVal - aVal;
//         }
        
//         // Convert to string for comparison
//         aVal = String(aVal).toLowerCase();
//         bVal = String(bVal).toLowerCase();
        
//         return sortConfig.direction === 'asc' 
//           ? aVal.localeCompare(bVal)
//           : bVal.localeCompare(aVal);
//       });
//     }

//     setFilteredAnimals(results);
//   }, [animals, searchTerm, sortConfig]);

//   // Sort Handler
//   const handleSort = (key) => {
//     let direction = 'asc';
//     if (sortConfig.key === key && sortConfig.direction === 'asc') {
//       direction = 'desc';
//     }
//     setSortConfig({ key, direction });
//   };

//   // Filter Handlers
//   const handleFilterChange = (key, value) => {
//     setFilters(prev => ({
//       ...prev,
//       [key]: value
//     }));
//   };

//   const resetFilters = () => {
//     setFilters({
//       species: "",
//       breed: "",
//       sex: "",
//       animal_type: ""
//     });
//     setSearchTerm("");
//     setSortConfig({ key: null, direction: 'asc' });
//   };

//   // Form Handlers
//   const handleFormChange = (e) => {
//     const { name, value } = e.target;
//     setForm(prev => {
//       const updatedForm = {
//         ...prev,
//         [name]: value
//       };

//       // Update animal class when species or sex changes
//       if ((name === 'species' || name === 'sex') && options.animal_classes) {
//         const speciesClasses = options.animal_classes[updatedForm.species] || {};
//         const classes = speciesClasses[updatedForm.sex] || [];
//         if (classes.length > 0 && !classes.includes(updatedForm.animal_class)) {
//           updatedForm.animal_class = classes[0];
//         } else if (classes.length === 0) {
//           updatedForm.animal_class = "";
//         }
//       }

//       return updatedForm;
//     });
//   };

//   // Submit Handlers
//   const handleCreateDraft = async (e) => {
//     e.preventDefault();
//     try {
//       const submitData = { 
//         ...form, 
//         lifecycle_state: "Draft",
//         created_by: "user"
//       };
      
//       // Convert empty strings to null for backend
//       Object.keys(submitData).forEach(key => {
//         if (submitData[key] === '') {
//           submitData[key] = null;
//         }
//       });

//       const res = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(submitData),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", "Animal draft created successfully!", "success");
//         closeAddModal();
//         fetchAnimals();
//         // Navigate to animal detail page if ID is returned
//         if (data.id) {
//           navigate(`/animals/${data.id}`);
//         }
//       } else {
//         swal("Error", data.error || "Something went wrong", "error");
//       }
//     } catch (err) {
//       console.error('Submit error:', err);
//       swal("Error", "Failed to create animal draft", "error");
//     }
//   };

//   const handleUpdateBasicInfo = async (e) => {
//     e.preventDefault();
//     if (!editingId) return;

//     try {
//       const submitData = { ...form };
      
//       Object.keys(submitData).forEach(key => {
//         if (submitData[key] === '') {
//           submitData[key] = null;
//         }
//       });

//       // Remove animal_type from submit data as it's not a backend field
//       delete submitData.animal_type;

//       const res = await fetch(`${API_URL}/${editingId}`, {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(submitData),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", data.message || "Animal updated successfully", "success");
//         closeEditModal();
//         fetchAnimals();
//       } else {
//         swal("Error", data.error || "Something went wrong", "error");
//       }
//     } catch (err) {
//       console.error('Update error:', err);
//       swal("Error", "Failed to update animal", "error");
//     }
//   };

//   const handleSubmitForApproval = async (animalId) => {
//     const confirm = await swal({
//       title: "Submit for Approval?",
//       text: "This will change the animal status to Active",
//       icon: "warning",
//       buttons: ["Cancel", "Submit"],
//       dangerMode: true,
//     });

//     if (confirm) {
//       try {
//         const res = await fetch(`${API_URL}/${animalId}/submit-approval`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ changed_by: "user" }),
//         });

//         const data = await res.json();
//         if (res.ok) {
//           swal("Success", data.message || "Animal submitted and activated!", "success");
//           fetchAnimals();
//         } else {
//           swal("Error", data.error || "Failed to submit for approval", "error");
//         }
//       } catch (err) {
//         console.error('Approval error:', err);
//         swal("Error", "Failed to submit for approval", "error");
//       }
//     }
//   };

//   // Delete Handler
//   const handleDelete = async (id) => {
//     const confirm = await swal({
//       title: "Are you sure?",
//       text: "This will permanently delete the animal!",
//       icon: "warning",
//       buttons: ["Cancel", "Delete"],
//       dangerMode: true,
//     });

//     if (confirm) {
//       try {
//         const res = await fetch(`${API_URL}/${id}`, { method: "DELETE" });
        
//         if (res.ok) {
//           const data = await res.json();
//           swal("Deleted!", data.message || "Animal deleted successfully", "success");
//           fetchAnimals();
//         } else {
//           const data = await res.json();
//           swal("Error", data.error || "Failed to delete animal", "error");
//         }
//       } catch (err) {
//         console.error('Delete error:', err);
//         swal("Error", "Failed to delete animal", "error");
//       }
//     }
//   };

//   // Modal Handlers
//   const openAddModal = () => {
//     setForm({
//       tag_number: "",
//       name: "",
//       species: "Cattle",
//       breed: "",
//       dob: "",
//       sex: "Female",
//       animal_class: "",
//       color: "",
//       lifecycle_state: "Draft",
//       animal_type: "born"
//     });
//     setAddModalOpen(true);
//   };

//   const closeAddModal = () => {
//     setAddModalOpen(false);
//   };

//   const openEditModal = (animal) => {
//     setEditingId(animal.id);
//     const formData = {};
    
//     // Map animal data to form fields
//     const fieldMapping = {
//       tag_number: 'tag_number',
//       name: 'name',
//       species: 'species',
//       breed: 'breed',
//       dob: 'dob',
//       sex: 'sex',
//       animal_class: 'animal_class',
//       color: 'color',
//       lifecycle_state: 'lifecycle_state'
//     };

//     Object.keys(fieldMapping).forEach(key => {
//       let value = animal[fieldMapping[key]];
//       if (value === null || value === undefined) {
//         value = "";
//       }
//       // Format date if it exists
//       if (value && typeof value === 'string' && value.includes('T')) {
//         value = value.split('T')[0];
//       }
//       formData[key] = value;
//     });
    
//     formData.animal_type = animal.purchase_price ? "purchased" : "born";
//     setForm(formData);
//     setEditModalOpen(true);
//   };

//   const closeEditModal = () => {
//     setEditModalOpen(false);
//     setEditingId(null);
//   };

//   // View Handler - Navigate to detail page
//   const handleView = (animalId) => {
//     navigate(`/animals/${animalId}`);
//   };

//   // Virtualized Table Content
//   const fixedHeaderContent = () => (
//     <TableRow>
//       {columns.map((column) => (
//         <TableCell
//           key={column.dataKey}
//           variant="head"
//           align="left"
//           style={{ width: column.width }}
//           sx={{ 
//             backgroundColor: colors.amber, 
//             color: 'black',
//             fontWeight: 'bold',
//             fontSize: '14px',
//             padding: '12px 8px'
//           }}
//         >
//           {column.dataKey !== 'actions' ? (
//             <TableSortLabel
//               active={sortConfig.key === column.dataKey}
//               direction={sortConfig.key === column.dataKey ? sortConfig.direction : 'asc'}
//               onClick={() => handleSort(column.dataKey)}
//               sx={{ color: 'black !important' }}
//             >
//               {column.label}
//             </TableSortLabel>
//           ) : (
//             column.label
//           )}
//         </TableCell>
//       ))}
//     </TableRow>
//   );

//   const rowContent = (index, animal) => (
//     <React.Fragment>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" fontWeight="bold" noWrap>
//           {animal.tag_number || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.name || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.species || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.breed || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Chip 
//           label={animal.animal_type === "purchased" ? "PURCHASED" : "BORN"} 
//           size="small"
//           sx={{ 
//             fontSize: '0.7rem', 
//             height: '24px',
//             backgroundColor: animal.animal_type === "purchased" ? colors.green : colors.amber,
//             color: 'black',
//             fontWeight: 'bold'
//           }}
//         />
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.age_string || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.sex || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.current_weight ? `${animal.current_weight} kg` : 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.location || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Chip 
//           label="DRAFT" 
//           size="small"
//           sx={{ 
//             fontSize: '0.7rem', 
//             height: '24px', 
//             fontWeight: 'bold',
//             backgroundColor: colors.amber,
//             color: 'black'
//           }}
//         />
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
//           <IconButton 
//             size="small" 
//             sx={{ 
//               minWidth: '32px', 
//               width: '32px', 
//               height: '32px',
//               color: colors.green 
//             }}
//             onClick={() => handleView(animal.id)}
//             title="View Details"
//           >
//             <ViewIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             sx={{ 
//               minWidth: '32px', 
//               width: '32px', 
//               height: '32px',
//               color: colors.amber 
//             }}
//             onClick={() => openEditModal(animal)}
//             title="Edit Animal"
//           >
//             <EditIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             color="error"
//             onClick={() => handleDelete(animal.id)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//             title="Delete Animal"
//           >
//             <DeleteIcon fontSize="small" />
//           </IconButton>
//           <Button 
//             size="small" 
//             variant="contained" 
//             sx={{ 
//               minWidth: 'auto',
//               px: 1,
//               fontSize: '0.7rem',
//               height: '32px',
//               backgroundColor: colors.green,
//               color: 'white',
//               '&:hover': {
//                 backgroundColor: colors.greenDark,
//               }
//             }}
//             onClick={() => handleSubmitForApproval(animal.id)}
//             title="Submit for Approval"
//           >
//             Submit
//           </Button>
//         </Box>
//       </TableCell>
//     </React.Fragment>
//   );

//   // Basic Info Form Component
//   const BasicInfoForm = ({ isEdit = false }) => (
//     <Grid container spacing={2}>
//       {!isEdit && (
//         <Grid item xs={12} sm={6}>
//           <FormControl fullWidth>
//             <InputLabel>Animal Type</InputLabel>
//             <Select
//               name="animal_type"
//               value={form.animal_type}
//               onChange={handleFormChange}
//               label="Animal Type"
//             >
//               <MenuItem value="born">Born on Farm</MenuItem>
//               <MenuItem value="purchased">Purchased</MenuItem>
//             </Select>
//           </FormControl>
//         </Grid>
//       )}
      
//       <Grid item xs={12} sm={isEdit ? 6 : 6}>
//         <TextField
//           fullWidth
//           label="Tag Number *"
//           name="tag_number"
//           value={form.tag_number}
//           onChange={handleFormChange}
//           required
//           error={!form.tag_number}
//           helperText={!form.tag_number ? "Tag number is required" : ""}
//         />
//       </Grid>

//       <Grid item xs={12} sm={6}>
//         <TextField
//           fullWidth
//           label="Name"
//           name="name"
//           value={form.name}
//           onChange={handleFormChange}
//           placeholder="Optional animal name"
//         />
//       </Grid>
      
//       <Grid item xs={12} sm={6}>
//         <FormControl fullWidth>
//           <InputLabel>Species</InputLabel>
//           <Select
//             name="species"
//             value={form.species}
//             onChange={handleFormChange}
//             label="Species"
//           >
//             {options.species?.map(species => (
//               <MenuItem key={species} value={species}>{species}</MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </Grid>

//       <Grid item xs={12} sm={6}>
//         <FormControl fullWidth required error={!form.breed}>
//           <InputLabel>Breed *</InputLabel>
//           <Select
//             name="breed"
//             value={form.breed}
//             onChange={handleFormChange}
//             label="Breed *"
//           >
//             <MenuItem value="">Select Breed</MenuItem>
//             {options.breeds?.[form.species]?.map(breed => (
//               <MenuItem key={breed} value={breed}>{breed}</MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </Grid>
      
//       <Grid item xs={12} sm={6}>
//         <TextField
//           fullWidth
//           label="Date of Birth *"
//           name="dob"
//           type="date"
//           value={form.dob}
//           onChange={handleFormChange}
//           InputLabelProps={{ shrink: true }}
//           required
//           error={!form.dob}
//           helperText={!form.dob ? "Date of birth is required" : ""}
//         />
//       </Grid>

//       <Grid item xs={12} sm={6}>
//         <FormControl fullWidth required error={!form.sex}>
//           <InputLabel>Gender *</InputLabel>
//           <Select
//             name="sex"
//             value={form.sex}
//             onChange={handleFormChange}
//             label="Gender *"
//           >
//             {options.sexes?.map(sex => (
//               <MenuItem key={sex} value={sex}>{sex}</MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </Grid>
      
//       <Grid item xs={12} sm={6}>
//         <FormControl fullWidth>
//           <InputLabel>Animal Class</InputLabel>
//           <Select
//             name="animal_class"
//             value={form.animal_class}
//             onChange={handleFormChange}
//             label="Animal Class"
//           >
//             <MenuItem value="">Select Class</MenuItem>
//             {options.animal_classes?.[form.species]?.[form.sex]?.map(cls => (
//               <MenuItem key={cls} value={cls}>{cls}</MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </Grid>

//       <Grid item xs={12} sm={6}>
//         <TextField
//           fullWidth
//           label="Color"
//           name="color"
//           value={form.color}
//           onChange={handleFormChange}
//           placeholder="Animal color/marking"
//         />
//       </Grid>
//     </Grid>
//   );

//   return (
//     <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
//       {/* Header */}
//       <AppBar position="static" elevation={2} sx={{ backgroundColor: colors.amber }}>
//         <Toolbar>
//           <PetsIcon sx={{ mr: 2, color: 'black' }} />
//           <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold', color: 'black' }}>
//             Draft Animals
//           </Typography>
//           <Chip 
//             label={`${animals.length} Draft${animals.length !== 1 ? 's' : ''}`} 
//             sx={{ 
//               color: 'black', 
//               fontWeight: 'bold', 
//               mr: 2,
//               backgroundColor: colors.amberLight 
//             }}
//           />
//           <Button 
//             variant="contained" 
//             startIcon={<AddIcon />}
//             onClick={openAddModal}
//             sx={{ 
//               borderRadius: 2, 
//               backgroundColor: colors.green,
//               color: 'white',
//               '&:hover': {
//                 backgroundColor: colors.greenDark,
//               }
//             }}
//           >
//             Add Draft
//           </Button>
//         </Toolbar>
//       </AppBar>

//       {/* Main Content */}
//       <Box sx={{ p: 3 }}>
//         <Paper sx={{ mb: 3, borderRadius: 2, border: 2, borderColor: colors.amberLight }}>
//           {/* Search and Filters */}
//           <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
//             <Grid container spacing={2} alignItems="center">
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   placeholder="Search draft animals by tag, name, breed..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   InputProps={{
//                     startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />,
//                   }}
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
//                   <Button
//                     startIcon={<FilterIcon />}
//                     onClick={() => setShowFilters(!showFilters)}
//                     variant={showFilters ? "contained" : "outlined"}
//                     size="small"
//                     sx={{
//                       backgroundColor: showFilters ? colors.amber : 'transparent',
//                       color: showFilters ? 'black' : colors.amber,
//                       borderColor: colors.amber,
//                       '&:hover': {
//                         backgroundColor: colors.amberLight,
//                         color: 'black'
//                       }
//                     }}
//                   >
//                     Filters
//                   </Button>
//                   <Button 
//                     onClick={resetFilters} 
//                     variant="outlined" 
//                     size="small" 
//                     sx={{
//                       color: colors.amber,
//                       borderColor: colors.amber,
//                       '&:hover': {
//                         backgroundColor: colors.amberLight,
//                         color: 'black'
//                       }
//                     }}
//                   >
//                     Reset
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>

//             {/* Expandable Filters */}
//             {showFilters && (
//               <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6} md={3}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Species</InputLabel>
//                       <Select
//                         value={filters.species}
//                         onChange={(e) => handleFilterChange('species', e.target.value)}
//                         label="Species"
//                       >
//                         <MenuItem value="">All Species</MenuItem>
//                         {options.species?.map(species => (
//                           <MenuItem key={species} value={species}>{species}</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={3}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Breed</InputLabel>
//                       <Select
//                         value={filters.breed}
//                         onChange={(e) => handleFilterChange('breed', e.target.value)}
//                         label="Breed"
//                         disabled={!filters.species}
//                       >
//                         <MenuItem value="">All Breeds</MenuItem>
//                         {options.breeds?.[filters.species]?.map(breed => (
//                           <MenuItem key={breed} value={breed}>{breed}</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={3}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Gender</InputLabel>
//                       <Select
//                         value={filters.sex}
//                         onChange={(e) => handleFilterChange('sex', e.target.value)}
//                         label="Gender"
//                       >
//                         <MenuItem value="">All Genders</MenuItem>
//                         {options.sexes?.map(sex => (
//                           <MenuItem key={sex} value={sex}>{sex}</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={3}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Type</InputLabel>
//                       <Select
//                         value={filters.animal_type}
//                         onChange={(e) => handleFilterChange('animal_type', e.target.value)}
//                         label="Type"
//                       >
//                         <MenuItem value="">All Types</MenuItem>
//                         <MenuItem value="born">Born</MenuItem>
//                         <MenuItem value="purchased">Purchased</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 </Grid>
//               </Box>
//             )}
//           </Box>

//           {/* Content Area */}
//           <Box sx={{ p: 2 }}>
//             <Alert 
//               severity="warning" 
//               sx={{ 
//                 mb: 2, 
//                 borderRadius: 2,
//                 backgroundColor: colors.amberLight,
//                 color: 'black',
//                 '& .MuiAlert-icon': {
//                   color: 'black'
//                 }
//               }}
//             >
//               <Typography variant="h6" gutterBottom>
//                 Draft Records - Pending Completion
//               </Typography>
//               Draft records are incomplete animal profiles. Complete the information and submit for approval to activate.
//             </Alert>
            
//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//                 <CircularProgress sx={{ color: colors.amber }} />
//                 <Typography sx={{ ml: 2 }}>Loading draft animals...</Typography>
//               </Box>
//             ) : filteredAnimals.length === 0 ? (
//               <Card sx={{ 
//                 textAlign: 'center', 
//                 p: 4, 
//                 border: 2, 
//                 borderColor: colors.amberLight,
//                 backgroundColor: colors.amberLight + '20'
//               }}>
//                 <CardContent>
//                   <PetsIcon sx={{ fontSize: 64, color: colors.amber, mb: 2 }} />
//                   <Typography variant="h5" sx={{ color: colors.amber }} gutterBottom>
//                     {animals.length === 0 ? "No draft animals found" : "No matching draft animals"}
//                   </Typography>
//                   <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
//                     {animals.length === 0 
//                       ? "Create a new draft to get started with animal management" 
//                       : "Try adjusting your search or filters to find what you're looking for"}
//                   </Typography>
//                   <Button 
//                     variant="contained" 
//                     sx={{ 
//                       backgroundColor: colors.green,
//                       color: 'white',
//                       '&:hover': {
//                         backgroundColor: colors.greenDark,
//                       }
//                     }} 
//                     onClick={openAddModal} 
//                     size="large"
//                   >
//                     Create First Draft
//                   </Button>
//                 </CardContent>
//               </Card>
//             ) : (
//               <Paper elevation={0} sx={{ 
//                 height: 600, 
//                 border: 1, 
//                 borderColor: colors.amberLight, 
//                 borderRadius: 1 
//               }}>
//                 <TableVirtuoso
//                   data={filteredAnimals}
//                   components={VirtuosoTableComponents}
//                   fixedHeaderContent={fixedHeaderContent}
//                   itemContent={rowContent}
//                 />
//               </Paper>
//             )}
//           </Box>
//         </Paper>
//       </Box>

//       {/* Add FAB for mobile */}
//       <Fab
//         sx={{
//           position: 'fixed',
//           bottom: 24,
//           right: 24,
//           display: { xs: 'flex', md: 'none' },
//           backgroundColor: colors.green,
//           color: 'white',
//           '&:hover': {
//             backgroundColor: colors.greenDark,
//           }
//         }}
//         onClick={openAddModal}
//       >
//         <AddIcon />
//       </Fab>

//       {/* Add Animal Modal */}
//       <Dialog 
//         open={addModalOpen} 
//         onClose={closeAddModal}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{ sx: { borderRadius: 2 } }}
//       >
//         <DialogTitle sx={{ backgroundColor: colors.amber, color: 'black' }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Typography variant="h5" fontWeight="bold">
//               Create New Animal Draft
//             </Typography>
//             <IconButton onClick={closeAddModal} size="small" sx={{ color: 'black' }}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" color="textSecondary" sx={{ mb: 3, mt: 2 }}>
//             Fill in the basic information to create a draft. You can complete the rest of the details on the animal's detail page.
//           </Typography>
//           <BasicInfoForm isEdit={false} />
//         </DialogContent>
//         <DialogActions sx={{ p: 3, gap: 1 }}>
//           <Button 
//             onClick={closeAddModal} 
//             variant="outlined" 
//             sx={{
//               color: colors.amber,
//               borderColor: colors.amber,
//               '&:hover': {
//                 backgroundColor: colors.amberLight,
//                 color: 'black'
//               }
//             }}
//           >
//             Cancel
//           </Button>
//           <Button 
//             variant="contained" 
//             sx={{
//               backgroundColor: colors.green,
//               color: 'white',
//               '&:hover': {
//                 backgroundColor: colors.greenDark,
//               },
//               minWidth: 140
//             }}
//             onClick={handleCreateDraft}
//             disabled={!form.tag_number || !form.breed || !form.dob || !form.sex}
//           >
//             Create Draft & Continue
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Edit Animal Modal */}
//       <Dialog 
//         open={editModalOpen} 
//         onClose={closeEditModal}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{ sx: { borderRadius: 2 } }}
//       >
//         <DialogTitle sx={{ backgroundColor: colors.amber, color: 'black' }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Typography variant="h5" fontWeight="bold">
//               Edit Draft Information
//             </Typography>
//             <IconButton onClick={closeEditModal} size="small" sx={{ color: 'black' }}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" color="textSecondary" sx={{ mb: 3, mt: 2 }}>
//             Update the basic information for this draft animal.
//           </Typography>
//           <BasicInfoForm isEdit={true} />
//         </DialogContent>
//         <DialogActions sx={{ p: 3, gap: 1 }}>
//           <Button 
//             onClick={closeEditModal} 
//             variant="outlined" 
//             sx={{
//               color: colors.amber,
//               borderColor: colors.amber,
//               '&:hover': {
//                 backgroundColor: colors.amberLight,
//                 color: 'black'
//               }
//             }}
//           >
//             Cancel
//           </Button>
//           <Button 
//             variant="contained" 
//             sx={{
//               backgroundColor: colors.green,
//               color: 'white',
//               '&:hover': {
//                 backgroundColor: colors.greenDark,
//               },
//               minWidth: 140
//             }}
//             onClick={handleUpdateBasicInfo}
//             disabled={!form.tag_number || !form.breed || !form.dob || !form.sex}
//           >
//             Update Draft
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default DraftAnimalsPage;





// import React, { useState, useEffect, useCallback, memo } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Chip,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Paper,
//   Grid,
//   Card,
//   CardContent,
//   Alert,
//   CircularProgress,
//   AppBar,
//   Toolbar,
//   Fab,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   TableSortLabel,
//   TableContainer,
// } from "@mui/material";
// import {
//   Add as AddIcon,
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   Visibility as ViewIcon,
//   Close as CloseIcon,
//   Pets as PetsIcon,
//   FilterList as FilterIcon,
//   Search as SearchIcon,
// } from "@mui/icons-material";
// import { TableVirtuoso } from "react-virtuoso";
// import { useNavigate } from "react-router-dom";
// import swal from "sweetalert";

// // Virtualized Table Components
// const VirtuosoTableComponents = {
//   Scroller: React.forwardRef((props, ref) => (
//     <TableContainer component={Paper} {...props} ref={ref} />
//   )),
//   Table: (props) => (
//     <Table
//       {...props}
//       sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
//     />
//   ),
//   TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
//   TableRow: (props) => <TableRow {...props} />,
//   TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
// };

// // Custom color theme - moved outside component
// const colors = {
//   amber: '#ffc107',
//   green: '#198754',
//   amberLight: '#ffecb3',
//   amberDark: '#ff8f00',
//   greenLight: '#4caf50',
//   greenDark: '#0d6e3d'
// };

// // Basic Info Form Component - memoized to prevent unnecessary re-renders
// const BasicInfoForm = memo(({ form, onFormChange, options, isEdit = false }) => {
//   const handleChange = useCallback((e) => {
//     onFormChange(e);
//   }, [onFormChange]);

//   return (
//     <Grid container spacing={2}>
//       {!isEdit && (
//         <Grid item xs={12} sm={6}>
//           <FormControl fullWidth>
//             <InputLabel>Animal Source</InputLabel>
//             <Select
//               name="animal_type"
//               value={form.animal_type}
//               onChange={handleChange}
//               label="Animal Source"
//             >
//               <MenuItem value="born">Born on Farm</MenuItem>
//               <MenuItem value="purchased">Purchased</MenuItem>
//             </Select>
//           </FormControl>
//         </Grid>
//       )}
      
//       <Grid item xs={12} sm={isEdit ? 6 : 6}>
//         <TextField
//           fullWidth
//           label="Tag Number *"
//           name="tag_number"
//           value={form.tag_number}
//           onChange={handleChange}
//           required
//           error={!form.tag_number}
//           helperText={!form.tag_number ? "Tag number is required" : ""}
//         />
//       </Grid>

//       <Grid item xs={12} sm={6}>
//         <TextField
//           fullWidth
//           label="Name"
//           name="name"
//           value={form.name}
//           onChange={handleChange}
//           placeholder="Optional animal name"
//         />
//       </Grid>
      
//       <Grid item xs={12} sm={6}>
//         <FormControl fullWidth>
//           <InputLabel>Species</InputLabel>
//           <Select
//             name="species"
//             value={form.species}
//             onChange={handleChange}
//             label="Species"
//           >
//             {options.species?.map(species => (
//               <MenuItem key={species} value={species}>{species}</MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </Grid>

//       <Grid item xs={12} sm={6}>
//         <FormControl fullWidth required error={!form.breed}>
//           <InputLabel>Breed *</InputLabel>
//           <Select
//             name="breed"
//             value={form.breed}
//             onChange={handleChange}
//             label="Breed *"
//           >
//             <MenuItem value="">Select Breed</MenuItem>
//             {options.breeds?.[form.species]?.map(breed => (
//               <MenuItem key={breed} value={breed}>{breed}</MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </Grid>
      
//       <Grid item xs={12} sm={6}>
//         <TextField
//           fullWidth
//           label="Date of Birth *"
//           name="dob"
//           type="date"
//           value={form.dob}
//           onChange={handleChange}
//           InputLabelProps={{ shrink: true }}
//           required
//           error={!form.dob}
//           helperText={!form.dob ? "Date of birth is required" : ""}
//         />
//       </Grid>

//       <Grid item xs={12} sm={6}>
//         <FormControl fullWidth required error={!form.sex}>
//           <InputLabel>Gender *</InputLabel>
//           <Select
//             name="sex"
//             value={form.sex}
//             onChange={handleChange}
//             label="Gender *"
//           >
//             {options.sexes?.map(sex => (
//               <MenuItem key={sex} value={sex}>{sex}</MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </Grid>
      
//       <Grid item xs={12} sm={6}>
//         <FormControl fullWidth>
//           <InputLabel>Animal Class</InputLabel>
//           <Select
//             name="animal_class"
//             value={form.animal_class}
//             onChange={handleChange}
//             label="Animal Class"
//           >
//             <MenuItem value="">Select Class</MenuItem>
//             {options.animal_classes?.[form.species]?.[form.sex]?.map(cls => (
//               <MenuItem key={cls} value={cls}>{cls}</MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </Grid>

//       <Grid item xs={12} sm={6}>
//         <TextField
//           fullWidth
//           label="Color"
//           name="color"
//           value={form.color}
//           onChange={handleChange}
//           placeholder="Animal color/marking"
//         />
//       </Grid>
//     </Grid>
//   );
// });

// const DraftAnimalsPage = () => {
//   const navigate = useNavigate();
//   const [animals, setAnimals] = useState([]);
//   const [filteredAnimals, setFilteredAnimals] = useState([]);
//   const [loading, setLoading] = useState(false);
  
//   // Modals
//   const [addModalOpen, setAddModalOpen] = useState(false);
//   const [editModalOpen, setEditModalOpen] = useState(false);
  
//   // Filters and Search
//   const [searchTerm, setSearchTerm] = useState("");
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
//   const [filters, setFilters] = useState({
//     species: "",
//     breed: "",
//     sex: "",
//     animal_type: ""
//   });

//   const [showFilters, setShowFilters] = useState(false);

//   // Options and Form Data
//   const [options, setOptions] = useState({
//     species: [],
//     breeds: {},
//     sexes: [],
//     animal_classes: {},
//     lifecycle_states: [],
//     reproductive_statuses: [],
//     pregnancy_statuses: [],
//     milking_statuses: [],
//     semen_statuses: [],
//     health_statuses: []
//   });

//   const [form, setForm] = useState({
//     tag_number: "",
//     name: "",
//     species: "Cattle",
//     breed: "",
//     dob: "",
//     sex: "Female",
//     animal_class: "",
//     color: "",
//     lifecycle_state: "Draft",
//     animal_type: "born"
//   });

//   const [editingId, setEditingId] = useState(null);

//   const API_URL = "http://127.0.0.1:5055/api/animals";

//   // Table Columns for Virtualized Table - moved outside to prevent recreation
//   const columns = [
//     { width: 120, label: 'Tag #', dataKey: 'tag_number' },
//     { width: 120, label: 'Name', dataKey: 'name' },
//     { width: 100, label: 'Species', dataKey: 'species' },
//     { width: 120, label: 'Breed', dataKey: 'breed' },
//     { width: 100, label: 'Type', dataKey: 'animal_type' },
//     { width: 80, label: 'Age', dataKey: 'age_string' },
//     { width: 80, label: 'Gender', dataKey: 'sex' },
//     { width: 100, label: 'Weight (kg)', dataKey: 'current_weight' },
//     { width: 120, label: 'Location', dataKey: 'location' },
//     { width: 100, label: 'Status', dataKey: 'lifecycle_state' },
//     { width: 180, label: 'Actions', dataKey: 'actions' },
//   ];

//   // Calculate age from DOB - useCallback to prevent recreation
//   const calculateAge = useCallback((dobString) => {
//     if (!dobString) return 'N/A';
    
//     try {
//       const dob = new Date(dobString);
//       const today = new Date();
//       let months = (today.getFullYear() - dob.getFullYear()) * 12;
//       months -= dob.getMonth();
//       months += today.getMonth();
      
//       if (months < 12) {
//         return `${months} month${months !== 1 ? 's' : ''}`;
//       } else {
//         const years = Math.floor(months / 12);
//         const remainingMonths = months % 12;
//         if (remainingMonths === 0) {
//           return `${years} year${years !== 1 ? 's' : ''}`;
//         }
//         return `${years}y ${remainingMonths}m`;
//       }
//     } catch (error) {
//       return 'N/A';
//     }
//   }, []);

//   // Enhanced animal data processing - useCallback to prevent recreation
//   const processAnimalData = useCallback((animal) => {
//     return {
//       ...animal,
//       age_string: calculateAge(animal.dob),
//       animal_type: animal.purchase_price ? "purchased" : "born"
//     };
//   }, [calculateAge]);

//   // Fetch Options
//   const fetchOptions = async () => {
//     try {
//       const res = await fetch(`${API_URL}/options`);
//       const data = await res.json();
//       if (res.ok) {
//         setOptions(data);
//       } else {
//         console.error('Failed to fetch options:', data.error);
//       }
//     } catch (err) {
//       console.error('Error fetching options:', err);
//       swal("Error", "Failed to load form options", "error");
//     }
//   };

//   // Fetch Draft Animals
//   const fetchAnimals = useCallback(async () => {
//     setLoading(true);
//     try {
//       const queryParams = new URLSearchParams();
//       Object.entries(filters).forEach(([key, value]) => {
//         if (value) queryParams.append(key, value);
//       });
//       queryParams.append('lifecycle_state', 'Draft');

//       const url = `${API_URL}?${queryParams.toString()}`;
//       const res = await fetch(url);
      
//       if (!res.ok) {
//         throw new Error(`HTTP error! status: ${res.status}`);
//       }
      
//       const data = await res.json();
      
//       let animalsArray = [];
//       if (data.animals && Array.isArray(data.animals)) {
//         animalsArray = data.animals.map(processAnimalData);
//       } else if (Array.isArray(data)) {
//         animalsArray = data.map(processAnimalData);
//       }
      
//       setAnimals(animalsArray);
//     } catch (err) {
//       console.error('Error fetching draft animals:', err);
//       swal("Error", "Failed to fetch draft animals", "error");
//       setAnimals([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [filters, processAnimalData]);

//   useEffect(() => {
//     fetchOptions();
//   }, []);

//   useEffect(() => {
//     fetchAnimals();
//   }, [fetchAnimals]);

//   // Filter animals based on search
//   useEffect(() => {
//     if (!Array.isArray(animals)) {
//       setFilteredAnimals([]);
//       return;
//     }
    
//     let results = animals;

//     // Apply search term
//     if (searchTerm) {
//       const searchLower = searchTerm.toLowerCase();
//       results = results.filter(animal =>
//         (animal.tag_number?.toLowerCase() || '').includes(searchLower) ||
//         (animal.name?.toLowerCase() || '').includes(searchLower) ||
//         (animal.breed?.toLowerCase() || '').includes(searchLower) ||
//         (animal.herd_id?.toLowerCase() || '').includes(searchLower) ||
//         (animal.location?.toLowerCase() || '').includes(searchLower)
//       );
//     }

//     // Apply sorting
//     if (sortConfig.key) {
//       results.sort((a, b) => {
//         let aVal = a[sortConfig.key];
//         let bVal = b[sortConfig.key];
        
//         // Handle null/undefined values
//         if (aVal == null) return sortConfig.direction === 'asc' ? 1 : -1;
//         if (bVal == null) return sortConfig.direction === 'asc' ? -1 : 1;
        
//         // Handle numeric values
//         if (typeof aVal === 'number' && typeof bVal === 'number') {
//           return sortConfig.direction === 'asc' ? aVal - bVal : bVal - aVal;
//         }
        
//         // Convert to string for comparison
//         aVal = String(aVal).toLowerCase();
//         bVal = String(bVal).toLowerCase();
        
//         return sortConfig.direction === 'asc' 
//           ? aVal.localeCompare(bVal)
//           : bVal.localeCompare(aVal);
//       });
//     }

//     setFilteredAnimals(results);
//   }, [animals, searchTerm, sortConfig]);

//   // Sort Handler - useCallback to prevent recreation
//   const handleSort = useCallback((key) => {
//     let direction = 'asc';
//     if (sortConfig.key === key && sortConfig.direction === 'asc') {
//       direction = 'desc';
//     }
//     setSortConfig({ key, direction });
//   }, [sortConfig]);

//   // Filter Handlers - useCallback to prevent recreation
//   const handleFilterChange = useCallback((key, value) => {
//     setFilters(prev => ({
//       ...prev,
//       [key]: value
//     }));
//   }, []);

//   const resetFilters = useCallback(() => {
//     setFilters({
//       species: "",
//       breed: "",
//       sex: "",
//       animal_type: ""
//     });
//     setSearchTerm("");
//     setSortConfig({ key: null, direction: 'asc' });
//   }, []);

//   // Form Handlers - useCallback to prevent recreation
//   const handleFormChange = useCallback((e) => {
//     const { name, value } = e.target;
//     setForm(prev => {
//       const updatedForm = {
//         ...prev,
//         [name]: value
//       };

//       // Update animal class when species or sex changes
//       if ((name === 'species' || name === 'sex') && options.animal_classes) {
//         const speciesClasses = options.animal_classes[updatedForm.species] || {};
//         const classes = speciesClasses[updatedForm.sex] || [];
//         if (classes.length > 0 && !classes.includes(updatedForm.animal_class)) {
//           updatedForm.animal_class = classes[0];
//         } else if (classes.length === 0) {
//           updatedForm.animal_class = "";
//         }
//       }

//       return updatedForm;
//     });
//   }, [options.animal_classes]);

//   // Submit Handlers - useCallback to prevent recreation
//   const handleCreateDraft = useCallback(async (e) => {
//     e.preventDefault();
//     try {
//       const submitData = { 
//         ...form, 
//         lifecycle_state: "Draft",
//         created_by: "user"
//       };
      
//       // Convert empty strings to null for backend
//       Object.keys(submitData).forEach(key => {
//         if (submitData[key] === '') {
//           submitData[key] = null;
//         }
//       });

//       const res = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(submitData),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", "Animal draft created successfully!", "success");
//         closeAddModal();
//         fetchAnimals();
//         // Navigate to animal detail page if ID is returned
//         if (data.id) {
//           navigate(`/animals/${data.id}`);
//         }
//       } else {
//         swal("Error", data.error || "Something went wrong", "error");
//       }
//     } catch (err) {
//       console.error('Submit error:', err);
//       swal("Error", "Failed to create animal draft", "error");
//     }
//   }, [form, fetchAnimals, navigate]);

//   const handleUpdateBasicInfo = useCallback(async (e) => {
//     e.preventDefault();
//     if (!editingId) return;

//     try {
//       const submitData = { ...form };
      
//       Object.keys(submitData).forEach(key => {
//         if (submitData[key] === '') {
//           submitData[key] = null;
//         }
//       });

//       // Remove animal_type from submit data as it's not a backend field
//       delete submitData.animal_type;

//       const res = await fetch(`${API_URL}/${editingId}`, {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(submitData),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", data.message || "Animal updated successfully", "success");
//         closeEditModal();
//         fetchAnimals();
//       } else {
//         swal("Error", data.error || "Something went wrong", "error");
//       }
//     } catch (err) {
//       console.error('Update error:', err);
//       swal("Error", "Failed to update animal", "error");
//     }
//   }, [form, editingId, fetchAnimals]);

//   const handleSubmitForApproval = useCallback(async (animalId) => {
//     const confirm = await swal({
//       title: "Submit for Approval?",
//       text: "This will change the animal status to Active",
//       icon: "warning",
//       buttons: ["Cancel", "Submit"],
//       dangerMode: true,
//     });

//     if (confirm) {
//       try {
//         const res = await fetch(`${API_URL}/${animalId}/submit-approval`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ changed_by: "user" }),
//         });

//         const data = await res.json();
//         if (res.ok) {
//           swal("Success", data.message || "Animal submitted and activated!", "success");
//           fetchAnimals();
//         } else {
//           swal("Error", data.error || "Failed to submit for approval", "error");
//         }
//       } catch (err) {
//         console.error('Approval error:', err);
//         swal("Error", "Failed to submit for approval", "error");
//       }
//     }
//   }, [fetchAnimals]);

//   // Delete Handler - useCallback to prevent recreation
//   const handleDelete = useCallback(async (id) => {
//     const confirm = await swal({
//       title: "Are you sure?",
//       text: "This will permanently delete the animal!",
//       icon: "warning",
//       buttons: ["Cancel", "Delete"],
//       dangerMode: true,
//     });

//     if (confirm) {
//       try {
//         const res = await fetch(`${API_URL}/${id}`, { method: "DELETE" });
        
//         if (res.ok) {
//           const data = await res.json();
//           swal("Deleted!", data.message || "Animal deleted successfully", "success");
//           fetchAnimals();
//         } else {
//           const data = await res.json();
//           swal("Error", data.error || "Failed to delete animal", "error");
//         }
//       } catch (err) {
//         console.error('Delete error:', err);
//         swal("Error", "Failed to delete animal", "error");
//       }
//     }
//   }, [fetchAnimals]);

//   // Modal Handlers - useCallback to prevent recreation
//   const openAddModal = useCallback(() => {
//     setForm({
//       tag_number: "",
//       name: "",
//       species: "Cattle",
//       breed: "",
//       dob: "",
//       sex: "Female",
//       animal_class: "",
//       color: "",
//       lifecycle_state: "Draft",
//       animal_type: "born"
//     });
//     setAddModalOpen(true);
//   }, []);

//   const closeAddModal = useCallback(() => {
//     setAddModalOpen(false);
//   }, []);

//   const openEditModal = useCallback((animal) => {
//     setEditingId(animal.id);
//     const formData = {};
    
//     // Map animal data to form fields
//     const fieldMapping = {
//       tag_number: 'tag_number',
//       name: 'name',
//       species: 'species',
//       breed: 'breed',
//       dob: 'dob',
//       sex: 'sex',
//       animal_class: 'animal_class',
//       color: 'color',
//       lifecycle_state: 'lifecycle_state'
//     };

//     Object.keys(fieldMapping).forEach(key => {
//       let value = animal[fieldMapping[key]];
//       if (value === null || value === undefined) {
//         value = "";
//       }
//       // Format date if it exists
//       if (value && typeof value === 'string' && value.includes('T')) {
//         value = value.split('T')[0];
//       }
//       formData[key] = value;
//     });
    
//     formData.animal_type = animal.purchase_price ? "purchased" : "born";
//     setForm(formData);
//     setEditModalOpen(true);
//   }, []);

//   const closeEditModal = useCallback(() => {
//     setEditModalOpen(false);
//     setEditingId(null);
//   }, []);

//   // View Handler - Navigate to detail page
//   const handleView = useCallback((animalId) => {
//     navigate(`/animals/${animalId}`);
//   }, [navigate]);

//   // Virtualized Table Content - useCallback to prevent recreation
//   const fixedHeaderContent = useCallback(() => (
//     <TableRow>
//       {columns.map((column) => (
//         <TableCell
//           key={column.dataKey}
//           variant="head"
//           align="left"
//           style={{ width: column.width }}
//           sx={{ 
//             backgroundColor: colors.amber, 
//             color: 'black',
//             fontWeight: 'bold',
//             fontSize: '14px',
//             padding: '12px 8px'
//           }}
//         >
//           {column.dataKey !== 'actions' ? (
//             <TableSortLabel
//               active={sortConfig.key === column.dataKey}
//               direction={sortConfig.key === column.dataKey ? sortConfig.direction : 'asc'}
//               onClick={() => handleSort(column.dataKey)}
//               sx={{ color: 'black !important' }}
//             >
//               {column.label}
//             </TableSortLabel>
//           ) : (
//             column.label
//           )}
//         </TableCell>
//       ))}
//     </TableRow>
//   ), [sortConfig, handleSort]);

//   const rowContent = useCallback((index, animal) => (
//     <React.Fragment>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" fontWeight="bold" noWrap>
//           {animal.tag_number || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.name || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.species || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.breed || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Chip 
//           label={animal.animal_type === "purchased" ? "PURCHASED" : "BORN"} 
//           size="small"
//           sx={{ 
//             fontSize: '0.7rem', 
//             height: '24px',
//             backgroundColor: animal.animal_type === "purchased" ? colors.green : colors.amber,
//             color: 'black',
//             fontWeight: 'bold'
//           }}
//         />
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.age_string || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.sex || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.current_weight ? `${animal.current_weight} kg` : 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.location || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Chip 
//           label="DRAFT" 
//           size="small"
//           sx={{ 
//             fontSize: '0.7rem', 
//             height: '24px', 
//             fontWeight: 'bold',
//             backgroundColor: colors.amber,
//             color: 'black'
//           }}
//         />
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
//           <IconButton 
//             size="small" 
//             sx={{ 
//               minWidth: '32px', 
//               width: '32px', 
//               height: '32px',
//               color: colors.green 
//             }}
//             onClick={() => handleView(animal.id)}
//             title="View Details"
//           >
//             <ViewIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             sx={{ 
//               minWidth: '32px', 
//               width: '32px', 
//               height: '32px',
//               color: colors.amber 
//             }}
//             onClick={() => openEditModal(animal)}
//             title="Edit Animal"
//           >
//             <EditIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             color="error"
//             onClick={() => handleDelete(animal.id)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//             title="Delete Animal"
//           >
//             <DeleteIcon fontSize="small" />
//           </IconButton>
//           <Button 
//             size="small" 
//             variant="contained" 
//             sx={{ 
//               minWidth: 'auto',
//               px: 1,
//               fontSize: '0.7rem',
//               height: '32px',
//               backgroundColor: colors.green,
//               color: 'white',
//               '&:hover': {
//                 backgroundColor: colors.greenDark,
//               }
//             }}
//             onClick={() => handleSubmitForApproval(animal.id)}
//             title="Submit for Approval"
//           >
//             Submit
//           </Button>
//         </Box>
//       </TableCell>
//     </React.Fragment>
//   ), [handleView, openEditModal, handleDelete, handleSubmitForApproval]);

//   return (
//     <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
//       {/* Header */}
//       <AppBar position="static" elevation={2} sx={{ backgroundColor: colors.amber }}>
//         <Toolbar>
//           <PetsIcon sx={{ mr: 2, color: 'black' }} />
//           <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold', color: 'black' }}>
//             Created Animals
//           </Typography>
//           <Chip 
//             label={`${animals.length} Draft${animals.length !== 1 ? 's' : ''}`} 
//             sx={{ 
//               color: 'black', 
//               fontWeight: 'bold', 
//               mr: 2,
//               backgroundColor: colors.amberLight 
//             }}
//           />
//           <Button 
//             variant="contained" 
//             startIcon={<AddIcon />}
//             onClick={openAddModal}
//             sx={{ 
//               borderRadius: 2, 
//               backgroundColor: colors.green,
//               color: 'white',
//               '&:hover': {
//                 backgroundColor: colors.greenDark,
//               }
//             }}
//           >
//             Add Animal
//           </Button>
//         </Toolbar>
//       </AppBar>

//       {/* Main Content */}
//       <Box sx={{ p: 3 }}>
//         <Paper sx={{ mb: 3, borderRadius: 2, border: 2, borderColor: colors.amberLight }}>
//           {/* Search and Filters */}
//           <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
//             <Grid container spacing={2} alignItems="center">
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   placeholder="Search draft animals by tag, name, breed..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   InputProps={{
//                     startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />,
//                   }}
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
//                   <Button
//                     startIcon={<FilterIcon />}
//                     onClick={() => setShowFilters(!showFilters)}
//                     variant={showFilters ? "contained" : "outlined"}
//                     size="small"
//                     sx={{
//                       backgroundColor: showFilters ? colors.amber : 'transparent',
//                       color: showFilters ? 'black' : colors.amber,
//                       borderColor: colors.amber,
//                       '&:hover': {
//                         backgroundColor: colors.amberLight,
//                         color: 'black'
//                       }
//                     }}
//                   >
//                     Filters
//                   </Button>
//                   <Button 
//                     onClick={resetFilters} 
//                     variant="outlined" 
//                     size="small" 
//                     sx={{
//                       color: colors.amber,
//                       borderColor: colors.amber,
//                       '&:hover': {
//                         backgroundColor: colors.amberLight,
//                         color: 'black'
//                       }
//                     }}
//                   >
//                     Reset
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>

//             {/* Expandable Filters */}
//             {showFilters && (
//               <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6} md={3}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Species</InputLabel>
//                       <Select
//                         value={filters.species}
//                         onChange={(e) => handleFilterChange('species', e.target.value)}
//                         label="Species"
//                       >
//                         <MenuItem value="">All Species</MenuItem>
//                         {options.species?.map(species => (
//                           <MenuItem key={species} value={species}>{species}</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={3}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Breed</InputLabel>
//                       <Select
//                         value={filters.breed}
//                         onChange={(e) => handleFilterChange('breed', e.target.value)}
//                         label="Breed"
//                         disabled={!filters.species}
//                       >
//                         <MenuItem value="">All Breeds</MenuItem>
//                         {options.breeds?.[filters.species]?.map(breed => (
//                           <MenuItem key={breed} value={breed}>{breed}</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={3}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Gender</InputLabel>
//                       <Select
//                         value={filters.sex}
//                         onChange={(e) => handleFilterChange('sex', e.target.value)}
//                         label="Gender"
//                       >
//                         <MenuItem value="">All Genders</MenuItem>
//                         {options.sexes?.map(sex => (
//                           <MenuItem key={sex} value={sex}>{sex}</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={3}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Type</InputLabel>
//                       <Select
//                         value={filters.animal_type}
//                         onChange={(e) => handleFilterChange('animal_type', e.target.value)}
//                         label="Type"
//                       >
//                         <MenuItem value="">All Types</MenuItem>
//                         <MenuItem value="born">Born</MenuItem>
//                         <MenuItem value="purchased">Purchased</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 </Grid>
//               </Box>
//             )}
//           </Box>

//           {/* Content Area */}
//           <Box sx={{ p: 2 }}>
           
            
//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//                 <CircularProgress sx={{ color: colors.amber }} />
//                 <Typography sx={{ ml: 2 }}>Loading draft animals...</Typography>
//               </Box>
//             ) : filteredAnimals.length === 0 ? (
//               <Card sx={{ 
//                 textAlign: 'center', 
//                 p: 4, 
//                 border: 2, 
//                 borderColor: colors.amberLight,
//                 backgroundColor: colors.amberLight + '20'
//               }}>
//                 <CardContent>
//                   <PetsIcon sx={{ fontSize: 64, color: colors.amber, mb: 2 }} />
//                   <Typography variant="h5" sx={{ color: colors.amber }} gutterBottom>
//                     {animals.length === 0 ? "No draft animals found" : "No matching draft animals"}
//                   </Typography>
//                   <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
//                     {animals.length === 0 
//                       ? "Create a new draft to get started with animal management" 
//                       : "Try adjusting your search or filters to find what you're looking for"}
//                   </Typography>
//                   <Button 
//                     variant="contained" 
//                     sx={{ 
//                       backgroundColor: colors.green,
//                       color: 'white',
//                       '&:hover': {
//                         backgroundColor: colors.greenDark,
//                       }
//                     }} 
//                     onClick={openAddModal} 
//                     size="large"
//                   >
//                     Create Animal
//                   </Button>
//                 </CardContent>
//               </Card>
//             ) : (
//               <Paper elevation={0} sx={{ 
//                 height: 600, 
//                 border: 1, 
//                 borderColor: colors.amberLight, 
//                 borderRadius: 1 
//               }}>
//                 <TableVirtuoso
//                   data={filteredAnimals}
//                   components={VirtuosoTableComponents}
//                   fixedHeaderContent={fixedHeaderContent}
//                   itemContent={rowContent}
//                 />
//               </Paper>
//             )}
//           </Box>
//         </Paper>
//       </Box>

//       {/* Add FAB for mobile */}
//       <Fab
//         sx={{
//           position: 'fixed',
//           bottom: 24,
//           right: 24,
//           display: { xs: 'flex', md: 'none' },
//           backgroundColor: colors.green,
//           color: 'white',
//           '&:hover': {
//             backgroundColor: colors.greenDark,
//           }
//         }}
//         onClick={openAddModal}
//       >
//         <AddIcon />
//       </Fab>

//       {/* Add Animal Modal */}
//       <Dialog 
//         open={addModalOpen} 
//         onClose={closeAddModal}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{ sx: { borderRadius: 2 } }}
//       >
//         <DialogTitle sx={{ backgroundColor: colors.amber, color: 'black' }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Typography variant="h5" fontWeight="bold">
//               Create New Animal 
//             </Typography>
//             <IconButton onClick={closeAddModal} size="small" sx={{ color: 'black' }}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" color="textSecondary" sx={{ mb: 3, mt: 2 }}>
//             Fill in the basic information to create a draft. You can complete the rest of the details on the animal's detail page.
//           </Typography>
//           <BasicInfoForm 
//             form={form}
//             onFormChange={handleFormChange}
//             options={options}
//             isEdit={false}
//           />
//         </DialogContent>
//         <DialogActions sx={{ p: 3, gap: 1 }}>
//           <Button 
//             onClick={closeAddModal} 
//             variant="outlined" 
//             sx={{
//               color: colors.amber,
//               borderColor: colors.amber,
//               '&:hover': {
//                 backgroundColor: colors.amberLight,
//                 color: 'black'
//               }
//             }}
//           >
//             Cancel
//           </Button>
//           <Button 
//             variant="contained" 
//             sx={{
//               backgroundColor: colors.green,
//               color: 'white',
//               '&:hover': {
//                 backgroundColor: colors.greenDark,
//               },
//               minWidth: 140
//             }}
//             onClick={handleCreateDraft}
//             disabled={!form.tag_number || !form.breed || !form.dob || !form.sex}
//           >
//             Create Draft & Continue
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Edit Animal Modal */}
//       <Dialog 
//         open={editModalOpen} 
//         onClose={closeEditModal}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{ sx: { borderRadius: 2 } }}
//       >
//         <DialogTitle sx={{ backgroundColor: colors.amber, color: 'black' }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Typography variant="h5" fontWeight="bold">
//               Edit Draft Information
//             </Typography>
//             <IconButton onClick={closeEditModal} size="small" sx={{ color: 'black' }}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" color="textSecondary" sx={{ mb: 3, mt: 2 }}>
//             Update the basic information for this draft animal.
//           </Typography>
//           <BasicInfoForm 
//             form={form}
//             onFormChange={handleFormChange}
//             options={options}
//             isEdit={true}
//           />
//         </DialogContent>
//         <DialogActions sx={{ p: 3, gap: 1 }}>
//           <Button 
//             onClick={closeEditModal} 
//             variant="outlined" 
//             sx={{
//               color: colors.amber,
//               borderColor: colors.amber,
//               '&:hover': {
//                 backgroundColor: colors.amberLight,
//                 color: 'black'
//               }
//             }}
//           >
//             Cancel
//           </Button>
//           <Button 
//             variant="contained" 
//             sx={{
//               backgroundColor: colors.green,
//               color: 'white',
//               '&:hover': {
//                 backgroundColor: colors.greenDark,
//               },
//               minWidth: 140
//             }}
//             onClick={handleUpdateBasicInfo}
//             disabled={!form.tag_number || !form.breed || !form.dob || !form.sex}
//           >
//             Update Draft
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default DraftAnimalsPage;



// import React, { useState, useEffect, useCallback, memo } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Chip,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Paper,
//   Grid,
//   Card,
//   CardContent,
//   Alert,
//   CircularProgress,
//   AppBar,
//   Toolbar,
//   Fab,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   TableSortLabel,
//   TableContainer,
//   FormHelperText,
//   Divider,
// } from "@mui/material";
// import {
//   Add as AddIcon,
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   Visibility as ViewIcon,
//   Close as CloseIcon,
//   Pets as PetsIcon,
//   FilterList as FilterIcon,
//   Search as SearchIcon,
// } from "@mui/icons-material";
// import { TableVirtuoso } from "react-virtuoso";
// import { useNavigate } from "react-router-dom";
// import swal from "sweetalert";

// // Virtualized Table Components
// const VirtuosoTableComponents = {
//   Scroller: React.forwardRef((props, ref) => (
//     <TableContainer component={Paper} {...props} ref={ref} />
//   )),
//   Table: (props) => (
//     <Table
//       {...props}
//       sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
//     />
//   ),
//   TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
//   TableRow: (props) => <TableRow {...props} />,
//   TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
// };

// // Custom color theme - moved outside component
// const colors = {
//   amber: '#FFA916',
//   green: '#024A59',
//   amberLight: '#FFA916',
//   amberDark: '#FFA916',
//   greenLight: '#024A59',
//   greenDark: '#024A59'
// };

// // Required Field Indicator Component
// const RequiredAsterisk = () => (
//   <Box component="span" sx={{ color: 'error.main', ml: 0.5 }}>*</Box>
// );

// // Field Label with Required Indicator
// const FieldLabel = ({ required, children }) => (
//   <Box sx={{ display: 'flex', alignItems: 'center' }}>
//     {children}
//     {required && <RequiredAsterisk />}
//   </Box>
// );

// // Section Header Component
// const SectionHeader = ({ title, subtitle }) => (
//   <Box sx={{ mb: 3 }}>
//     <Typography variant="h6" sx={{ 
//       fontWeight: 'bold', 
//       color: 'text.primary',
//       fontSize: '1.1rem',
//       display: 'flex',
//       alignItems: 'center',
//       gap: 1
//     }}>
//       {title}
//     </Typography>
//     {subtitle && (
//       <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
//         {subtitle}
//       </Typography>
//     )}
//   </Box>
// );

// // Basic Info Form Component - memoized to prevent unnecessary re-renders
// const BasicInfoForm = memo(({ form, onFormChange, options, isEdit = false }) => {
//   const handleChange = useCallback((e) => {
//     onFormChange(e);
//   }, [onFormChange]);

//   return (
//     <Box sx={{ mt: 1 }}>
//       {/* Animal Source Section */}
//       <SectionHeader 
//         title="Animal Source" 
//         subtitle="Select how this animal was acquired"
//       />
      
//       <Grid container spacing={3} sx={{ mb: 4 }}>
//         {!isEdit && (
//           <Grid item xs={12} md={6}>
//             <FormControl fullWidth size="medium">
//               <InputLabel>
//                 <FieldLabel required={false}>Animal Source</FieldLabel>
//               </InputLabel>
//               <Select
//                 name="animal_type"
//                 value={form.animal_type}
//                 onChange={handleChange}
//                 label={<FieldLabel required={false}>Animal Source</FieldLabel>}
//               >
//                 <MenuItem value="born">Born on Farm → Tag Number</MenuItem>
//                 <MenuItem value="purchased">Purchased</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>
//         )}
//       </Grid>

//       <Divider sx={{ my: 3 }} />

//       {/* Basic Information Section */}
//       <SectionHeader 
//         title="Basic Information" 
//         subtitle="Enter the essential details about the animal"
//       />
      
//       <Grid container spacing={3}>
//         {/* First Row - Identification */}
//         <Grid item xs={12} md={6}>
//           <TextField
//             fullWidth
//             label={<FieldLabel required={true}>Tag Number</FieldLabel>}
//             name="tag_number"
//             value={form.tag_number}
//             onChange={handleChange}
//             required
//             error={!form.tag_number}
//             helperText={!form.tag_number ? "Tag number is required" : "Unique identifier for the animal"}
//             placeholder="Enter tag number"
//             size="medium"
//             sx={{ mb: 1 }}
//           />
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <TextField
//             fullWidth
//             label={<FieldLabel required={false}>Name</FieldLabel>}
//             name="name"
//             value={form.name}
//             onChange={handleChange}
//             placeholder="Optional animal name"
//             size="medium"
//             sx={{ mb: 1 }}
//             helperText="Give your animal a friendly name (optional)"
//           />
//         </Grid>

//         {/* Second Row - Species and Breed */}
//         <Grid item xs={12} md={6}>
//           <FormControl fullWidth size="medium" sx={{ mb: 1 }}>
//             <InputLabel>
//               <FieldLabel required={false}>Species</FieldLabel>
//             </InputLabel>
//             <Select
//               name="species"
//               value={form.species}
//               onChange={handleChange}
//               label={<FieldLabel required={false}>Species</FieldLabel>}
//             >
//               {options.species?.map(species => (
//                 <MenuItem key={species} value={species}>{species}</MenuItem>
//               ))}
//             </Select>
//             <FormHelperText>Select the animal species</FormHelperText>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <FormControl fullWidth size="medium" required error={!form.breed} sx={{ mb: 1 }}>
//             <InputLabel>
//               <FieldLabel required={true}>Breed</FieldLabel>
//             </InputLabel>
//             <Select
//               name="breed"
//               value={form.breed}
//               onChange={handleChange}
//               label={<FieldLabel required={true}>Breed</FieldLabel>}
//             >
//               <MenuItem value="">Select Breed</MenuItem>
//               {options.breeds?.[form.species]?.map(breed => (
//                 <MenuItem key={breed} value={breed}>{breed}</MenuItem>
//               ))}
//             </Select>
//             {!form.breed ? (
//               <FormHelperText error>Breed selection is required</FormHelperText>
//             ) : (
//               <FormHelperText>Select the animal breed</FormHelperText>
//             )}
//           </FormControl>
//         </Grid>

//         {/* Third Row - Date of Birth and Gender */}
//         <Grid item xs={12} md={6}>
//           <TextField
//             fullWidth
//             label={<FieldLabel required={true}>Date of Birth</FieldLabel>}
//             name="dob"
//             type="date"
//             value={form.dob}
//             onChange={handleChange}
//             InputLabelProps={{ shrink: true }}
//             required
//             error={!form.dob}
//             helperText={!form.dob ? "Date of birth is required" : "Animal's birth date"}
//             size="medium"
//             sx={{ mb: 1 }}
//           />
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <FormControl fullWidth size="medium" required error={!form.sex} sx={{ mb: 1 }}>
//             <InputLabel>
//               <FieldLabel required={true}>Gender</FieldLabel>
//             </InputLabel>
//             <Select
//               name="sex"
//               value={form.sex}
//               onChange={handleChange}
//               label={<FieldLabel required={true}>Gender</FieldLabel>}
//             >
//               {options.sexes?.map(sex => (
//                 <MenuItem key={sex} value={sex}>{sex}</MenuItem>
//               ))}
//             </Select>
//             {!form.sex ? (
//               <FormHelperText error>Gender selection is required</FormHelperText>
//             ) : (
//               <FormHelperText>Select the animal's gender</FormHelperText>
//             )}
//           </FormControl>
//         </Grid>

//         {/* Fourth Row - Animal Class and Color */}
//         <Grid item xs={12} md={6}>
//           <FormControl fullWidth size="medium" sx={{ mb: 1 }}>
//             <InputLabel>
//               <FieldLabel required={false}>Animal Class</FieldLabel>
//             </InputLabel>
//             <Select
//               name="animal_class"
//               value={form.animal_class}
//               onChange={handleChange}
//               label={<FieldLabel required={false}>Animal Class</FieldLabel>}
//             >
//               <MenuItem value="">Select Class</MenuItem>
//               {options.animal_classes?.[form.species]?.[form.sex]?.map(cls => (
//                 <MenuItem key={cls} value={cls}>{cls}</MenuItem>
//               ))}
//             </Select>
//             <FormHelperText>
//               {form.species && form.sex 
//                 ? "Classification based on species and gender" 
//                 : "Select species and gender first"}
//             </FormHelperText>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <TextField
//             fullWidth
//             label={<FieldLabel required={false}>Color</FieldLabel>}
//             name="color"
//             value={form.color}
//             onChange={handleChange}
//             placeholder="Animal color or markings"
//             size="medium"
//             sx={{ mb: 1 }}
//             helperText="Describe the animal's color or distinctive markings"
//           />
//         </Grid>
//       </Grid>

//       {/* Required Fields Note */}
//       <Box sx={{ mt: 4, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//         <Typography variant="caption" color="textSecondary" sx={{ fontStyle: 'italic' }}>
//           * Indicates required field
//         </Typography>
//       </Box>
//     </Box>
//   );
// });

// const DraftAnimalsPage = () => {
//   const navigate = useNavigate();
//   const [animals, setAnimals] = useState([]);
//   const [filteredAnimals, setFilteredAnimals] = useState([]);
//   const [loading, setLoading] = useState(false);
  
//   // Modals
//   const [addModalOpen, setAddModalOpen] = useState(false);
//   const [editModalOpen, setEditModalOpen] = useState(false);
  
//   // Filters and Search
//   const [searchTerm, setSearchTerm] = useState("");
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
//   const [filters, setFilters] = useState({
//     species: "",
//     breed: "",
//     sex: "",
//     animal_type: ""
//   });

//   const [showFilters, setShowFilters] = useState(false);

//   // Options and Form Data
//   const [options, setOptions] = useState({
//     species: [],
//     breeds: {},
//     sexes: [],
//     animal_classes: {},
//     lifecycle_states: [],
//     reproductive_statuses: [],
//     pregnancy_statuses: [],
//     milking_statuses: [],
//     semen_statuses: [],
//     health_statuses: []
//   });

//   const [form, setForm] = useState({
//     tag_number: "",
//     name: "",
//     species: "Cattle",
//     breed: "",
//     dob: "",
//     sex: "Female",
//     animal_class: "",
//     color: "",
//     lifecycle_state: "Draft",
//     animal_type: "born"
//   });

//   const [editingId, setEditingId] = useState(null);

//   const API_URL = "https://dairy.server.statify.co.ke/api/animals";

//   // Table Columns for Virtualized Table - moved outside to prevent recreation
//   const columns = [
//     { width: 120, label: 'Tag #', dataKey: 'tag_number' },
//     { width: 120, label: 'Name', dataKey: 'name' },
//     { width: 100, label: 'Species', dataKey: 'species' },
//     { width: 120, label: 'Breed', dataKey: 'breed' },
//     { width: 100, label: 'Type', dataKey: 'animal_type' },
//     { width: 80, label: 'Age', dataKey: 'age_string' },
//     { width: 80, label: 'Gender', dataKey: 'sex' },
//     { width: 100, label: 'Weight (kg)', dataKey: 'current_weight' },
//     { width: 120, label: 'Location', dataKey: 'location' },
//     { width: 100, label: 'Status', dataKey: 'lifecycle_state' },
//     { width: 180, label: 'Actions', dataKey: 'actions' },
//   ];

//   // Calculate age from DOB - useCallback to prevent recreation
//   const calculateAge = useCallback((dobString) => {
//     if (!dobString) return 'N/A';
    
//     try {
//       const dob = new Date(dobString);
//       const today = new Date();
//       let months = (today.getFullYear() - dob.getFullYear()) * 12;
//       months -= dob.getMonth();
//       months += today.getMonth();
      
//       if (months < 12) {
//         return `${months} month${months !== 1 ? 's' : ''}`;
//       } else {
//         const years = Math.floor(months / 12);
//         const remainingMonths = months % 12;
//         if (remainingMonths === 0) {
//           return `${years} year${years !== 1 ? 's' : ''}`;
//         }
//         return `${years}y ${remainingMonths}m`;
//       }
//     } catch (error) {
//       return 'N/A';
//     }
//   }, []);

//   // Enhanced animal data processing - useCallback to prevent recreation
//   const processAnimalData = useCallback((animal) => {
//     return {
//       ...animal,
//       age_string: calculateAge(animal.dob),
//       animal_type: animal.purchase_price ? "purchased" : "born"
//     };
//   }, [calculateAge]);

//   // Fetch Options
//   const fetchOptions = async () => {
//     try {
//       const res = await fetch(`${API_URL}/options`);
//       const data = await res.json();
//       if (res.ok) {
//         setOptions(data);
//       } else {
//         console.error('Failed to fetch options:', data.error);
//       }
//     } catch (err) {
//       console.error('Error fetching options:', err);
//       swal("Error", "Failed to load form options", "error");
//     }
//   };

//   // Fetch Draft Animals
//   const fetchAnimals = useCallback(async () => {
//     setLoading(true);
//     try {
//       const queryParams = new URLSearchParams();
//       Object.entries(filters).forEach(([key, value]) => {
//         if (value) queryParams.append(key, value);
//       });
//       queryParams.append('lifecycle_state', 'Draft');

//       const url = `${API_URL}?${queryParams.toString()}`;
//       const res = await fetch(url);
      
//       if (!res.ok) {
//         throw new Error(`HTTP error! status: ${res.status}`);
//       }
      
//       const data = await res.json();
      
//       let animalsArray = [];
//       if (data.animals && Array.isArray(data.animals)) {
//         animalsArray = data.animals.map(processAnimalData);
//       } else if (Array.isArray(data)) {
//         animalsArray = data.map(processAnimalData);
//       }
      
//       setAnimals(animalsArray);
//     } catch (err) {
//       console.error('Error fetching draft animals:', err);
//       swal("Error", "Failed to fetch draft animals", "error");
//       setAnimals([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [filters, processAnimalData]);

//   useEffect(() => {
//     fetchOptions();
//   }, []);

//   useEffect(() => {
//     fetchAnimals();
//   }, [fetchAnimals]);

//   // Filter animals based on search
//   useEffect(() => {
//     if (!Array.isArray(animals)) {
//       setFilteredAnimals([]);
//       return;
//     }
    
//     let results = animals;

//     // Apply search term
//     if (searchTerm) {
//       const searchLower = searchTerm.toLowerCase();
//       results = results.filter(animal =>
//         (animal.tag_number?.toLowerCase() || '').includes(searchLower) ||
//         (animal.name?.toLowerCase() || '').includes(searchLower) ||
//         (animal.breed?.toLowerCase() || '').includes(searchLower) ||
//         (animal.herd_id?.toLowerCase() || '').includes(searchLower) ||
//         (animal.location?.toLowerCase() || '').includes(searchLower)
//       );
//     }

//     // Apply sorting
//     if (sortConfig.key) {
//       results.sort((a, b) => {
//         let aVal = a[sortConfig.key];
//         let bVal = b[sortConfig.key];
        
//         // Handle null/undefined values
//         if (aVal == null) return sortConfig.direction === 'asc' ? 1 : -1;
//         if (bVal == null) return sortConfig.direction === 'asc' ? -1 : 1;
        
//         // Handle numeric values
//         if (typeof aVal === 'number' && typeof bVal === 'number') {
//           return sortConfig.direction === 'asc' ? aVal - bVal : bVal - aVal;
//         }
        
//         // Convert to string for comparison
//         aVal = String(aVal).toLowerCase();
//         bVal = String(bVal).toLowerCase();
        
//         return sortConfig.direction === 'asc' 
//           ? aVal.localeCompare(bVal)
//           : bVal.localeCompare(aVal);
//       });
//     }

//     setFilteredAnimals(results);
//   }, [animals, searchTerm, sortConfig]);

//   // Sort Handler - useCallback to prevent recreation
//   const handleSort = useCallback((key) => {
//     let direction = 'asc';
//     if (sortConfig.key === key && sortConfig.direction === 'asc') {
//       direction = 'desc';
//     }
//     setSortConfig({ key, direction });
//   }, [sortConfig]);

//   // Filter Handlers - useCallback to prevent recreation
//   const handleFilterChange = useCallback((key, value) => {
//     setFilters(prev => ({
//       ...prev,
//       [key]: value
//     }));
//   }, []);

//   const resetFilters = useCallback(() => {
//     setFilters({
//       species: "",
//       breed: "",
//       sex: "",
//       animal_type: ""
//     });
//     setSearchTerm("");
//     setSortConfig({ key: null, direction: 'asc' });
//   }, []);

//   // Form Handlers - useCallback to prevent recreation
//   const handleFormChange = useCallback((e) => {
//     const { name, value } = e.target;
//     setForm(prev => {
//       const updatedForm = {
//         ...prev,
//         [name]: value
//       };

//       // Update animal class when species or sex changes
//       if ((name === 'species' || name === 'sex') && options.animal_classes) {
//         const speciesClasses = options.animal_classes[updatedForm.species] || {};
//         const classes = speciesClasses[updatedForm.sex] || [];
//         if (classes.length > 0 && !classes.includes(updatedForm.animal_class)) {
//           updatedForm.animal_class = classes[0];
//         } else if (classes.length === 0) {
//           updatedForm.animal_class = "";
//         }
//       }

//       return updatedForm;
//     });
//   }, [options.animal_classes]);

//   // Submit Handlers - useCallback to prevent recreation
//   const handleCreateDraft = useCallback(async (e) => {
//     e.preventDefault();
//     try {
//       const submitData = { 
//         ...form, 
//         lifecycle_state: "Draft",
//         created_by: "user"
//       };
      
//       // Convert empty strings to null for backend
//       Object.keys(submitData).forEach(key => {
//         if (submitData[key] === '') {
//           submitData[key] = null;
//         }
//       });

//       const res = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(submitData),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", "Animal draft created successfully!", "success");
//         closeAddModal();
//         fetchAnimals();
//         // Navigate to animal detail page if ID is returned
//         if (data.id) {
//           navigate(`/animals/${data.id}`);
//         }
//       } else {
//         swal("Error", data.error || "Something went wrong", "error");
//       }
//     } catch (err) {
//       console.error('Submit error:', err);
//       swal("Error", "Failed to onboard animal draft", "error");
//     }
//   }, [form, fetchAnimals, navigate]);

//   const handleUpdateBasicInfo = useCallback(async (e) => {
//     e.preventDefault();
//     if (!editingId) return;

//     try {
//       const submitData = { ...form };
      
//       Object.keys(submitData).forEach(key => {
//         if (submitData[key] === '') {
//           submitData[key] = null;
//         }
//       });

//       // Remove animal_type from submit data as it's not a backend field
//       delete submitData.animal_type;

//       const res = await fetch(`${API_URL}/${editingId}`, {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(submitData),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", data.message || "Animal updated successfully", "success");
//         closeEditModal();
//         fetchAnimals();
//       } else {
//         swal("Error", data.error || "Something went wrong", "error");
//       }
//     } catch (err) {
//       console.error('Update error:', err);
//       swal("Error", "Failed to update animal", "error");
//     }
//   }, [form, editingId, fetchAnimals]);

//   const handleSubmitForApproval = useCallback(async (animalId) => {
//     const confirm = await swal({
//       title: "Submit for Approval?",
//       text: "This will change the animal status to Active",
//       icon: "warning",
//       buttons: ["Cancel", "Submit"],
//       dangerMode: true,
//     });

//     if (confirm) {
//       try {
//         const res = await fetch(`${API_URL}/${animalId}/submit-approval`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ changed_by: "user" }),
//         });

//         const data = await res.json();
//         if (res.ok) {
//           swal("Success", data.message || "Animal submitted and activated!", "success");
//           fetchAnimals();
//         } else {
//           swal("Error", data.error || "Failed to submit for approval", "error");
//         }
//       } catch (err) {
//         console.error('Approval error:', err);
//         swal("Error", "Failed to submit for approval", "error");
//       }
//     }
//   }, [fetchAnimals]);

//   // Delete Handler - useCallback to prevent recreation
//   const handleDelete = useCallback(async (id) => {
//     const confirm = await swal({
//       title: "Are you sure?",
//       text: "This will permanently delete the animal!",
//       icon: "warning",
//       buttons: ["Cancel", "Delete"],
//       dangerMode: true,
//     });

//     if (confirm) {
//       try {
//         const res = await fetch(`${API_URL}/${id}`, { method: "DELETE" });
        
//         if (res.ok) {
//           const data = await res.json();
//           swal("Deleted!", data.message || "Animal deleted successfully", "success");
//           fetchAnimals();
//         } else {
//           const data = await res.json();
//           swal("Error", data.error || "Failed to delete animal", "error");
//         }
//       } catch (err) {
//         console.error('Delete error:', err);
//         swal("Error", "Failed to delete animal", "error");
//       }
//     }
//   }, [fetchAnimals]);

//   // Modal Handlers - useCallback to prevent recreation
//   const openAddModal = useCallback(() => {
//     setForm({
//       tag_number: "",
//       name: "",
//       species: "Cattle",
//       breed: "",
//       dob: "",
//       sex: "Female",
//       animal_class: "",
//       color: "",
//       lifecycle_state: "Draft",
//       animal_type: "born"
//     });
//     setAddModalOpen(true);
//   }, []);

//   const closeAddModal = useCallback(() => {
//     setAddModalOpen(false);
//   }, []);

//   const openEditModal = useCallback((animal) => {
//     setEditingId(animal.id);
//     const formData = {};
    
//     // Map animal data to form fields
//     const fieldMapping = {
//       tag_number: 'tag_number',
//       name: 'name',
//       species: 'species',
//       breed: 'breed',
//       dob: 'dob',
//       sex: 'sex',
//       animal_class: 'animal_class',
//       color: 'color',
//       lifecycle_state: 'lifecycle_state'
//     };

//     Object.keys(fieldMapping).forEach(key => {
//       let value = animal[fieldMapping[key]];
//       if (value === null || value === undefined) {
//         value = "";
//       }
//       // Format date if it exists
//       if (value && typeof value === 'string' && value.includes('T')) {
//         value = value.split('T')[0];
//       }
//       formData[key] = value;
//     });
    
//     formData.animal_type = animal.purchase_price ? "purchased" : "born";
//     setForm(formData);
//     setEditModalOpen(true);
//   }, []);

//   const closeEditModal = useCallback(() => {
//     setEditModalOpen(false);
//     setEditingId(null);
//   }, []);

//   // View Handler - Navigate to detail page
//   const handleView = useCallback((animalId) => {
//     navigate(`/animals/${animalId}`);
//   }, [navigate]);

//   // Virtualized Table Content - useCallback to prevent recreation
//   const fixedHeaderContent = useCallback(() => (
//     <TableRow>
//       {columns.map((column) => (
//         <TableCell
//           key={column.dataKey}
//           variant="head"
//           align="left"
//           style={{ width: column.width }}
//           sx={{ 
//             backgroundColor: colors.amber, 
//             color: 'black',
//             fontWeight: 'bold',
//             fontSize: '14px',
//             padding: '12px 8px'
//           }}
//         >
//           {column.dataKey !== 'actions' ? (
//             <TableSortLabel
//               active={sortConfig.key === column.dataKey}
//               direction={sortConfig.key === column.dataKey ? sortConfig.direction : 'asc'}
//               onClick={() => handleSort(column.dataKey)}
//               sx={{ color: 'black !important' }}
//             >
//               {column.label}
//             </TableSortLabel>
//           ) : (
//             column.label
//           )}
//         </TableCell>
//       ))}
//     </TableRow>
//   ), [sortConfig, handleSort]);

//   const rowContent = useCallback((index, animal) => (
//     <React.Fragment>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" fontWeight="bold" noWrap>
//           {animal.tag_number || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.name || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.species || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.breed || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Chip 
//           label={animal.animal_type === "purchased" ? "PURCHASED" : "BORN"} 
//           size="small"
//           sx={{ 
//             fontSize: '0.7rem', 
//             height: '24px',
//             backgroundColor: animal.animal_type === "purchased" ? colors.green : colors.amber,
//             color: 'black',
//             fontWeight: 'bold'
//           }}
//         />
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.age_string || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.sex || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.current_weight ? `${animal.current_weight} kg` : 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.location || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Chip 
//           label="DRAFT" 
//           size="small"
//           sx={{ 
//             fontSize: '0.7rem', 
//             height: '24px', 
//             fontWeight: 'bold',
//             backgroundColor: colors.amber,
//             color: 'black'
//           }}
//         />
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
//           <IconButton 
//             size="small" 
//             sx={{ 
//               minWidth: '32px', 
//               width: '32px', 
//               height: '32px',
//               color: colors.green 
//             }}
//             onClick={() => handleView(animal.id)}
//             title="View Details"
//           >
//             <ViewIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             sx={{ 
//               minWidth: '32px', 
//               width: '32px', 
//               height: '32px',
//               color: colors.amber 
//             }}
//             onClick={() => openEditModal(animal)}
//             title="Edit Animal"
//           >
//             <EditIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             color="error"
//             onClick={() => handleDelete(animal.id)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//             title="Delete Animal"
//           >
//             <DeleteIcon fontSize="small" />
//           </IconButton>
//           <Button 
//             size="small" 
//             variant="contained" 
//             sx={{ 
//               minWidth: 'auto',
//               px: 1,
//               fontSize: '0.7rem',
//               height: '32px',
//               backgroundColor: colors.green,
//               color: 'white',
//               '&:hover': {
//                 backgroundColor: colors.greenDark,
//               }
//             }}
//             onClick={() => handleSubmitForApproval(animal.id)}
//             title="Submit for Approval"
//           >
//             Submit
//           </Button>
//         </Box>
//       </TableCell>
//     </React.Fragment>
//   ), [handleView, openEditModal, handleDelete, handleSubmitForApproval]);

//   return (
//     <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
//       {/* Header */}
//       <AppBar position="static" elevation={2} sx={{ backgroundColor: colors.amber }}>
//         <Toolbar>
//           <PetsIcon sx={{ mr: 2, color: 'black' }} />
//           <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold', color: 'black' }}>
//             Onboarding Animal
//           </Typography>
//           <Chip 
//             label={`${animals.length} Draft${animals.length !== 1 ? 's' : ''}`} 
//             sx={{ 
//               color: 'black', 
//               fontWeight: 'bold', 
//               mr: 2,
//               backgroundColor: colors.amberLight 
//             }}
//           />
//           <Button 
//             variant="contained" 
//             startIcon={<AddIcon />}
//             onClick={openAddModal}
//             sx={{ 
//               borderRadius: 2, 
//               backgroundColor: colors.green,
//               color: 'white',
//               '&:hover': {
//                 backgroundColor: colors.greenDark,
//               }
//             }}
//           >
//             Onboard Animal
//           </Button>
//         </Toolbar>
//       </AppBar>

//       {/* Main Content */}
//       <Box sx={{ p: 3 }}>
//         <Paper sx={{ mb: 3, borderRadius: 2, border: 2, borderColor: colors.amberLight }}>
//           {/* Search and Filters */}
//           <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
//             <Grid container spacing={2} alignItems="center">
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   placeholder="Search draft animals by tag, name, breed..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   InputProps={{
//                     startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />,
//                   }}
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
//                   <Button
//                     startIcon={<FilterIcon />}
//                     onClick={() => setShowFilters(!showFilters)}
//                     variant={showFilters ? "contained" : "outlined"}
//                     size="small"
//                     sx={{
//                       backgroundColor: showFilters ? colors.amber : 'transparent',
//                       color: showFilters ? 'black' : colors.amber,
//                       borderColor: colors.amber,
//                       '&:hover': {
//                         backgroundColor: colors.amberLight,
//                         color: 'black'
//                       }
//                     }}
//                   >
//                     Filters
//                   </Button>
//                   <Button 
//                     onClick={resetFilters} 
//                     variant="outlined" 
//                     size="small" 
//                     sx={{
//                       color: colors.amber,
//                       borderColor: colors.amber,
//                       '&:hover': {
//                         backgroundColor: colors.amberLight,
//                         color: 'black'
//                       }
//                     }}
//                   >
//                     Reset
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>

//             {/* Expandable Filters */}
//             {showFilters && (
//               <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6} md={3}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Species</InputLabel>
//                       <Select
//                         value={filters.species}
//                         onChange={(e) => handleFilterChange('species', e.target.value)}
//                         label="Species"
//                       >
//                         <MenuItem value="">All Species</MenuItem>
//                         {options.species?.map(species => (
//                           <MenuItem key={species} value={species}>{species}</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={3}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Breed</InputLabel>
//                       <Select
//                         value={filters.breed}
//                         onChange={(e) => handleFilterChange('breed', e.target.value)}
//                         label="Breed"
//                         disabled={!filters.species}
//                       >
//                         <MenuItem value="">All Breeds</MenuItem>
//                         {options.breeds?.[filters.species]?.map(breed => (
//                           <MenuItem key={breed} value={breed}>{breed}</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={3}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Gender</InputLabel>
//                       <Select
//                         value={filters.sex}
//                         onChange={(e) => handleFilterChange('sex', e.target.value)}
//                         label="Gender"
//                       >
//                         <MenuItem value="">All Genders</MenuItem>
//                         {options.sexes?.map(sex => (
//                           <MenuItem key={sex} value={sex}>{sex}</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={3}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Type</InputLabel>
//                       <Select
//                         value={filters.animal_type}
//                         onChange={(e) => handleFilterChange('animal_type', e.target.value)}
//                         label="Type"
//                       >
//                         <MenuItem value="">All Types</MenuItem>
//                         <MenuItem value="born">Born</MenuItem>
//                         <MenuItem value="purchased">Purchased</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 </Grid>
//               </Box>
//             )}
//           </Box>

//           {/* Content Area */}
//           <Box sx={{ p: 2 }}>
           
            
//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//                 <CircularProgress sx={{ color: colors.amber }} />
//                 <Typography sx={{ ml: 2 }}>Loading draft animals...</Typography>
//               </Box>
//             ) : filteredAnimals.length === 0 ? (
//               <Card sx={{ 
//                 textAlign: 'center', 
//                 p: 4, 
//                 border: 2, 
//                 borderColor: colors.amberLight,
//                 backgroundColor: colors.amberLight + '20'
//               }}>
//                 <CardContent>
//                   <PetsIcon sx={{ fontSize: 64, color: colors.amber, mb: 2 }} />
//                   <Typography variant="h5" sx={{ color: colors.amber }} gutterBottom>
//                     {animals.length === 0 ? "No draft animals found" : "No matching draft animals"}
//                   </Typography>
//                   <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
//                     {animals.length === 0 
//                       ? "Create a new draft to get started with animal management" 
//                       : "Try adjusting your search or filters to find what you're looking for"}
//                   </Typography>
//                   <Button 
//                     variant="contained" 
//                     sx={{ 
//                       backgroundColor: colors.green,
//                       color: 'white',
//                       '&:hover': {
//                         backgroundColor: colors.greenDark,
//                       }
//                     }} 
//                     onClick={openAddModal} 
//                     size="large"
//                   >
//                    Onboarding Animal
//                   </Button>
//                 </CardContent>
//               </Card>
//             ) : (
//               <Paper elevation={0} sx={{ 
//                 height: 600, 
//                 border: 1, 
//                 borderColor: colors.amberLight, 
//                 borderRadius: 1 
//               }}>
//                 <TableVirtuoso
//                   data={filteredAnimals}
//                   components={VirtuosoTableComponents}
//                   fixedHeaderContent={fixedHeaderContent}
//                   itemContent={rowContent}
//                 />
//               </Paper>
//             )}
//           </Box>
//         </Paper>
//       </Box>

//       {/* Add FAB for mobile */}
//       <Fab
//         sx={{
//           position: 'fixed',
//           bottom: 24,
//           right: 24,
//           display: { xs: 'flex', md: 'none' },
//           backgroundColor: colors.green,
//           color: 'white',
//           '&:hover': {
//             backgroundColor: colors.greenDark,
//           }
//         }}
//         onClick={openAddModal}
//       >
//         <AddIcon />
//       </Fab>

//       {/* Add Animal Modal */}
//       <Dialog 
//         open={addModalOpen} 
//         onClose={closeAddModal}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{ 
//           sx: { 
//             borderRadius: 2,
//             minHeight: '600px'
//           } 
//         }}
//       >
//         <DialogTitle sx={{ 
//           backgroundColor: colors.amber, 
//           color: 'black',
//           borderBottom: 1,
//           borderColor: 'divider'
//         }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Typography variant="h5" fontWeight="bold">
//               Onboarding New Animal 
//             </Typography>
//             <IconButton onClick={closeAddModal} size="small" sx={{ color: 'black' }}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent sx={{ p: 3 }}>
//           <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
//             Fill in the basic information to onboard an animal. You can complete the rest of the details on the animal's detail page.
//           </Typography>
//           <BasicInfoForm 
//             form={form}
//             onFormChange={handleFormChange}
//             options={options}
//             isEdit={false}
//           />
//         </DialogContent>
//         <DialogActions sx={{ p: 3, gap: 1, borderTop: 1, borderColor: 'divider' }}>
//           <Button 
//             onClick={closeAddModal} 
//             variant="outlined" 
//             sx={{
//               color: colors.amber,
//               borderColor: colors.amber,
//               '&:hover': {
//                 backgroundColor: colors.amberLight,
//                 color: 'black'
//               },
//               minWidth: 100
//             }}
//           >
//             Cancel
//           </Button>
//           <Button 
//             variant="contained" 
//             sx={{
//               backgroundColor: colors.green,
//               color: 'white',
//               '&:hover': {
//                 backgroundColor: colors.greenDark,
//               },
//               minWidth: 200
//             }}
//             onClick={handleCreateDraft}
//             disabled={!form.tag_number || !form.breed || !form.dob || !form.sex}
//           >
//             Create Draft & Continue
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Edit Animal Modal */}
//       <Dialog 
//         open={editModalOpen} 
//         onClose={closeEditModal}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{ sx: { borderRadius: 2 } }}
//       >
//         <DialogTitle sx={{ backgroundColor: colors.amber, color: 'black' }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Typography variant="h5" fontWeight="bold">
//               Edit Draft Information
//             </Typography>
//             <IconButton onClick={closeEditModal} size="small" sx={{ color: 'black' }}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" color="textSecondary" sx={{ mb: 3, mt: 2 }}>
//             Update the basic information for this draft animal.
//           </Typography>
//           <BasicInfoForm 
//             form={form}
//             onFormChange={handleFormChange}
//             options={options}
//             isEdit={true}
//           />
//         </DialogContent>
//         <DialogActions sx={{ p: 3, gap: 1 }}>
//           <Button 
//             onClick={closeEditModal} 
//             variant="outlined" 
//             sx={{
//               color: colors.amber,
//               borderColor: colors.amber,
//               '&:hover': {
//                 backgroundColor: colors.amberLight,
//                 color: 'black'
//               }
//             }}
//           >
//             Cancel
//           </Button>
//           <Button 
//             variant="contained" 
//             sx={{
//               backgroundColor: colors.green,
//               color: 'white',
//               '&:hover': {
//                 backgroundColor: colors.greenDark,
//               },
//               minWidth: 140
//             }}
//             onClick={handleUpdateBasicInfo}
//             disabled={!form.tag_number || !form.breed || !form.dob || !form.sex}
//           >
//             Update Draft
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default DraftAnimalsPage;



import React, { useState, useEffect, useCallback, memo } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  Grid,
  Card,
  CardContent,
  Alert,
  CircularProgress,
  AppBar,
  Toolbar,
  Fab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  TableContainer,
  FormHelperText,
  Divider,
} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  Close as CloseIcon,
  Pets as PetsIcon,
  FilterList as FilterIcon,
  Search as SearchIcon,
} from "@mui/icons-material";
import { TableVirtuoso } from "react-virtuoso";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

// Virtualized Table Components
const VirtuosoTableComponents = {
  Scroller: React.forwardRef((props, ref) => (
    <TableContainer component={Paper} {...props} ref={ref} />
  )),
  Table: (props) => (
    <Table
      {...props}
      sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
    />
  ),
  TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
  TableRow: (props) => <TableRow {...props} />,
  TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
};

// Updated color theme with new colors
const colors = {
  primary: '#024A59',
  secondary: '#FFA916',
  primaryLight: '#03718C',
  secondaryLight: '#FFBA4D',
  primaryDark: '#01313D',
  secondaryDark: '#E59400'
};

// Required Field Indicator Component
const RequiredAsterisk = () => (
  <Box component="span" sx={{ color: 'error.main', ml: 0.5 }}>*</Box>
);

// Field Label with Required Indicator
const FieldLabel = ({ required, children }) => (
  <Box sx={{ display: 'flex', alignItems: 'center' }}>
    {children}
    {required && <RequiredAsterisk />}
  </Box>
);

// Section Header Component
const SectionHeader = ({ title, subtitle }) => (
  <Box sx={{ mb: 3 }}>
    <Typography variant="h6" sx={{ 
      fontWeight: 'bold', 
      color: colors.primary,
      fontSize: '1.1rem',
      display: 'flex',
      alignItems: 'center',
      gap: 1
    }}>
      {title}
    </Typography>
    {subtitle && (
      <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
        {subtitle}
      </Typography>
    )}
  </Box>
);

// Basic Info Form Component - memoized to prevent unnecessary re-renders
const BasicInfoForm = memo(({ form, onFormChange, options, isEdit = false }) => {
  const handleChange = useCallback((e) => {
    onFormChange(e);
  }, [onFormChange]);

  return (
    <Box sx={{ mt: 1 }}>
      {/* Animal Source Section */}
      <SectionHeader 
        title="Animal Source" 
        subtitle="Select how this animal was acquired"
      />
      
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {!isEdit && (
          <Grid item xs={12} md={6}>
            <FormControl fullWidth size="medium">
              <InputLabel>
                <FieldLabel required={false}>Animal Source</FieldLabel>
              </InputLabel>
              <Select
                name="animal_type"
                value={form.animal_type}
                onChange={handleChange}
                label={<FieldLabel required={false}>Animal Source</FieldLabel>}
              >
                <MenuItem value="born">Born on Farm → Tag Number</MenuItem>
                <MenuItem value="purchased">Purchased</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        )}
      </Grid>

      <Divider sx={{ my: 3 }} />

      {/* Basic Information Section */}
      <SectionHeader 
        title="Basic Information" 
        subtitle="Enter the essential details about the animal"
      />
      
      <Grid container spacing={3}>
        {/* First Row - Identification */}
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label={<FieldLabel required={true}>Tag Number</FieldLabel>}
            name="tag_number"
            value={form.tag_number}
            onChange={handleChange}
            required
            error={!form.tag_number}
            helperText={!form.tag_number ? "Tag number is required" : "Unique identifier for the animal"}
            placeholder="Enter tag number"
            size="medium"
            sx={{ mb: 1 }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label={<FieldLabel required={false}>Name</FieldLabel>}
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Optional animal name"
            size="medium"
            sx={{ mb: 1 }}
            helperText="Give your animal a friendly name (optional)"
          />
        </Grid>

        {/* Second Row - Species and Breed */}
        <Grid item xs={12} md={6}>
          <FormControl fullWidth size="medium" sx={{ mb: 1 }}>
            <InputLabel>
              <FieldLabel required={false}>Species</FieldLabel>
            </InputLabel>
            <Select
              name="species"
              value={form.species}
              onChange={handleChange}
              label={<FieldLabel required={false}>Species</FieldLabel>}
            >
              {options.species?.map(species => (
                <MenuItem key={species} value={species}>{species}</MenuItem>
              ))}
            </Select>
            <FormHelperText>Select the animal species</FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth size="medium" required error={!form.breed} sx={{ mb: 1 }}>
            <InputLabel>
              <FieldLabel required={true}>Breed</FieldLabel>
            </InputLabel>
            <Select
              name="breed"
              value={form.breed}
              onChange={handleChange}
              label={<FieldLabel required={true}>Breed</FieldLabel>}
            >
              <MenuItem value="">Select Breed</MenuItem>
              {options.breeds?.[form.species]?.map(breed => (
                <MenuItem key={breed} value={breed}>{breed}</MenuItem>
              ))}
            </Select>
            {!form.breed ? (
              <FormHelperText error>Breed selection is required</FormHelperText>
            ) : (
              <FormHelperText>Select the animal breed</FormHelperText>
            )}
          </FormControl>
        </Grid>

        {/* Third Row - Date of Birth and Gender */}
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label={<FieldLabel required={true}>Date of Birth</FieldLabel>}
            name="dob"
            type="date"
            value={form.dob}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            required
            error={!form.dob}
            helperText={!form.dob ? "Date of birth is required" : "Animal's birth date"}
            size="medium"
            sx={{ mb: 1 }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth size="medium" required error={!form.sex} sx={{ mb: 1 }}>
            <InputLabel>
              <FieldLabel required={true}>Gender</FieldLabel>
            </InputLabel>
            <Select
              name="sex"
              value={form.sex}
              onChange={handleChange}
              label={<FieldLabel required={true}>Gender</FieldLabel>}
            >
              {options.sexes?.map(sex => (
                <MenuItem key={sex} value={sex}>{sex}</MenuItem>
              ))}
            </Select>
            {!form.sex ? (
              <FormHelperText error>Gender selection is required</FormHelperText>
            ) : (
              <FormHelperText>Select the animal's gender</FormHelperText>
            )}
          </FormControl>
        </Grid>

        {/* Fourth Row - Animal Class and Color */}
        <Grid item xs={12} md={6}>
          <FormControl fullWidth size="medium" sx={{ mb: 1 }}>
            <InputLabel>
              <FieldLabel required={false}>Animal Class</FieldLabel>
            </InputLabel>
            <Select
              name="animal_class"
              value={form.animal_class}
              onChange={handleChange}
              label={<FieldLabel required={false}>Animal Class</FieldLabel>}
            >
              <MenuItem value="">Select Class</MenuItem>
              {options.animal_classes?.[form.species]?.[form.sex]?.map(cls => (
                <MenuItem key={cls} value={cls}>{cls}</MenuItem>
              ))}
            </Select>
            <FormHelperText>
              {form.species && form.sex 
                ? "Classification based on species and gender" 
                : "Select species and gender first"}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label={<FieldLabel required={false}>Color</FieldLabel>}
            name="color"
            value={form.color}
            onChange={handleChange}
            placeholder="Animal color or markings"
            size="medium"
            sx={{ mb: 1 }}
            helperText="Describe the animal's color or distinctive markings"
          />
        </Grid>
      </Grid>

      {/* Required Fields Note */}
      <Box sx={{ mt: 4, pt: 2, borderTop: 1, borderColor: 'divider' }}>
        <Typography variant="caption" color="textSecondary" sx={{ fontStyle: 'italic' }}>
          * Indicates required field
        </Typography>
      </Box>
    </Box>
  );
});

const DraftAnimalsPage = () => {
  const navigate = useNavigate();
  const [animals, setAnimals] = useState([]);
  const [filteredAnimals, setFilteredAnimals] = useState([]);
  const [loading, setLoading] = useState(false);
  
  // Modals
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  
  // Filters and Search
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [filters, setFilters] = useState({
    species: "",
    breed: "",
    sex: "",
    animal_type: ""
  });

  const [showFilters, setShowFilters] = useState(false);

  // Options and Form Data
  const [options, setOptions] = useState({
    species: [],
    breeds: {},
    sexes: [],
    animal_classes: {},
    lifecycle_states: [],
    reproductive_statuses: [],
    pregnancy_statuses: [],
    milking_statuses: [],
    semen_statuses: [],
    health_statuses: []
  });

  const [form, setForm] = useState({
    tag_number: "",
    name: "",
    species: "Cattle",
    breed: "",
    dob: "",
    sex: "Female",
    animal_class: "",
    color: "",
    lifecycle_state: "Draft",
    animal_type: "born"
  });

  const [editingId, setEditingId] = useState(null);

  const API_URL = "https://dairy.server.statify.co.ke/api/animals";

  // Table Columns for Virtualized Table - moved outside to prevent recreation
  const columns = [
    { width: 120, label: 'Tag #', dataKey: 'tag_number' },
    { width: 120, label: 'Name', dataKey: 'name' },
    { width: 100, label: 'Species', dataKey: 'species' },
    { width: 120, label: 'Breed', dataKey: 'breed' },
    { width: 100, label: 'Type', dataKey: 'animal_type' },
    { width: 80, label: 'Age', dataKey: 'age_string' },
    { width: 80, label: 'Gender', dataKey: 'sex' },
    { width: 100, label: 'Weight (kg)', dataKey: 'current_weight' },
    { width: 120, label: 'Location', dataKey: 'location' },
    { width: 100, label: 'Status', dataKey: 'lifecycle_state' },
    { width: 180, label: 'Actions', dataKey: 'actions' },
  ];

  // Calculate age from DOB - useCallback to prevent recreation
  const calculateAge = useCallback((dobString) => {
    if (!dobString) return 'N/A';
    
    try {
      const dob = new Date(dobString);
      const today = new Date();
      let months = (today.getFullYear() - dob.getFullYear()) * 12;
      months -= dob.getMonth();
      months += today.getMonth();
      
      if (months < 12) {
        return `${months} month${months !== 1 ? 's' : ''}`;
      } else {
        const years = Math.floor(months / 12);
        const remainingMonths = months % 12;
        if (remainingMonths === 0) {
          return `${years} year${years !== 1 ? 's' : ''}`;
        }
        return `${years}y ${remainingMonths}m`;
      }
    } catch (error) {
      return 'N/A';
    }
  }, []);

  // Enhanced animal data processing - useCallback to prevent recreation
  const processAnimalData = useCallback((animal) => {
    return {
      ...animal,
      age_string: calculateAge(animal.dob),
      animal_type: animal.purchase_price ? "purchased" : "born"
    };
  }, [calculateAge]);

  // Fetch Options
  const fetchOptions = async () => {
    try {
      const res = await fetch(`${API_URL}/options`);
      const data = await res.json();
      if (res.ok) {
        setOptions(data);
      } else {
        console.error('Failed to fetch options:', data.error);
      }
    } catch (err) {
      console.error('Error fetching options:', err);
      swal("Error", "Failed to load form options", "error");
    }
  };

  // Fetch Draft Animals
  const fetchAnimals = useCallback(async () => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value) queryParams.append(key, value);
      });
      queryParams.append('lifecycle_state', 'Draft');

      const url = `${API_URL}?${queryParams.toString()}`;
      const res = await fetch(url);
      
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      
      const data = await res.json();
      
      let animalsArray = [];
      if (data.animals && Array.isArray(data.animals)) {
        animalsArray = data.animals.map(processAnimalData);
      } else if (Array.isArray(data)) {
        animalsArray = data.map(processAnimalData);
      }
      
      setAnimals(animalsArray);
    } catch (err) {
      console.error('Error fetching draft animals:', err);
      swal("Error", "Failed to fetch draft animals", "error");
      setAnimals([]);
    } finally {
      setLoading(false);
    }
  }, [filters, processAnimalData]);

  useEffect(() => {
    fetchOptions();
  }, []);

  useEffect(() => {
    fetchAnimals();
  }, [fetchAnimals]);

  // Filter animals based on search
  useEffect(() => {
    if (!Array.isArray(animals)) {
      setFilteredAnimals([]);
      return;
    }
    
    let results = animals;

    // Apply search term
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      results = results.filter(animal =>
        (animal.tag_number?.toLowerCase() || '').includes(searchLower) ||
        (animal.name?.toLowerCase() || '').includes(searchLower) ||
        (animal.breed?.toLowerCase() || '').includes(searchLower) ||
        (animal.herd_id?.toLowerCase() || '').includes(searchLower) ||
        (animal.location?.toLowerCase() || '').includes(searchLower)
      );
    }

    // Apply sorting
    if (sortConfig.key) {
      results.sort((a, b) => {
        let aVal = a[sortConfig.key];
        let bVal = b[sortConfig.key];
        
        // Handle null/undefined values
        if (aVal == null) return sortConfig.direction === 'asc' ? 1 : -1;
        if (bVal == null) return sortConfig.direction === 'asc' ? -1 : 1;
        
        // Handle numeric values
        if (typeof aVal === 'number' && typeof bVal === 'number') {
          return sortConfig.direction === 'asc' ? aVal - bVal : bVal - aVal;
        }
        
        // Convert to string for comparison
        aVal = String(aVal).toLowerCase();
        bVal = String(bVal).toLowerCase();
        
        return sortConfig.direction === 'asc' 
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
      });
    }

    setFilteredAnimals(results);
  }, [animals, searchTerm, sortConfig]);

  // Sort Handler - useCallback to prevent recreation
  const handleSort = useCallback((key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  }, [sortConfig]);

  // Filter Handlers - useCallback to prevent recreation
  const handleFilterChange = useCallback((key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  }, []);

  const resetFilters = useCallback(() => {
    setFilters({
      species: "",
      breed: "",
      sex: "",
      animal_type: ""
    });
    setSearchTerm("");
    setSortConfig({ key: null, direction: 'asc' });
  }, []);

  // Form Handlers - useCallback to prevent recreation
  const handleFormChange = useCallback((e) => {
    const { name, value } = e.target;
    setForm(prev => {
      const updatedForm = {
        ...prev,
        [name]: value
      };

      // Update animal class when species or sex changes
      if ((name === 'species' || name === 'sex') && options.animal_classes) {
        const speciesClasses = options.animal_classes[updatedForm.species] || {};
        const classes = speciesClasses[updatedForm.sex] || [];
        if (classes.length > 0 && !classes.includes(updatedForm.animal_class)) {
          updatedForm.animal_class = classes[0];
        } else if (classes.length === 0) {
          updatedForm.animal_class = "";
        }
      }

      return updatedForm;
    });
  }, [options.animal_classes]);

  // Submit Handlers - useCallback to prevent recreation
  const handleCreateDraft = useCallback(async (e) => {
    e.preventDefault();
    try {
      const submitData = { 
        ...form, 
        lifecycle_state: "Draft",
        created_by: "user"
      };
      
      // Convert empty strings to null for backend
      Object.keys(submitData).forEach(key => {
        if (submitData[key] === '') {
          submitData[key] = null;
        }
      });

      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(submitData),
      });

      const data = await res.json();
      if (res.ok) {
        swal("Success", "Animal draft created successfully!", "success");
        closeAddModal();
        fetchAnimals();
        // Navigate to animal detail page if ID is returned
        if (data.id) {
          navigate(`/animals/${data.id}`);
        }
      } else {
        swal("Error", data.error || "Something went wrong", "error");
      }
    } catch (err) {
      console.error('Submit error:', err);
      swal("Error", "Failed to onboard animal draft", "error");
    }
  }, [form, fetchAnimals, navigate]);

  const handleUpdateBasicInfo = useCallback(async (e) => {
    e.preventDefault();
    if (!editingId) return;

    try {
      const submitData = { ...form };
      
      Object.keys(submitData).forEach(key => {
        if (submitData[key] === '') {
          submitData[key] = null;
        }
      });

      // Remove animal_type from submit data as it's not a backend field
      delete submitData.animal_type;

      const res = await fetch(`${API_URL}/${editingId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(submitData),
      });

      const data = await res.json();
      if (res.ok) {
        swal("Success", data.message || "Animal updated successfully", "success");
        closeEditModal();
        fetchAnimals();
      } else {
        swal("Error", data.error || "Something went wrong", "error");
      }
    } catch (err) {
      console.error('Update error:', err);
      swal("Error", "Failed to update animal", "error");
    }
  }, [form, editingId, fetchAnimals]);

  const handleSubmitForApproval = useCallback(async (animalId) => {
    const confirm = await swal({
      title: "Submit for Approval?",
      text: "This will change the animal status to Active",
      icon: "warning",
      buttons: ["Cancel", "Submit"],
      dangerMode: true,
    });

    if (confirm) {
      try {
        const res = await fetch(`${API_URL}/${animalId}/submit-approval`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ changed_by: "user" }),
        });

        const data = await res.json();
        if (res.ok) {
          swal("Success", data.message || "Animal submitted and activated!", "success");
          fetchAnimals();
        } else {
          swal("Error", data.error || "Failed to submit for approval", "error");
        }
      } catch (err) {
        console.error('Approval error:', err);
        swal("Error", "Failed to submit for approval", "error");
      }
    }
  }, [fetchAnimals]);

  // Delete Handler - useCallback to prevent recreation
  const handleDelete = useCallback(async (id) => {
    const confirm = await swal({
      title: "Are you sure?",
      text: "This will permanently delete the animal!",
      icon: "warning",
      buttons: ["Cancel", "Delete"],
      dangerMode: true,
    });

    if (confirm) {
      try {
        const res = await fetch(`${API_URL}/${id}`, { method: "DELETE" });
        
        if (res.ok) {
          const data = await res.json();
          swal("Deleted!", data.message || "Animal deleted successfully", "success");
          fetchAnimals();
        } else {
          const data = await res.json();
          swal("Error", data.error || "Failed to delete animal", "error");
        }
      } catch (err) {
        console.error('Delete error:', err);
        swal("Error", "Failed to delete animal", "error");
      }
    }
  }, [fetchAnimals]);

  // Modal Handlers - useCallback to prevent recreation
  const openAddModal = useCallback(() => {
    setForm({
      tag_number: "",
      name: "",
      species: "Cattle",
      breed: "",
      dob: "",
      sex: "Female",
      animal_class: "",
      color: "",
      lifecycle_state: "Draft",
      animal_type: "born"
    });
    setAddModalOpen(true);
  }, []);

  const closeAddModal = useCallback(() => {
    setAddModalOpen(false);
  }, []);

  const openEditModal = useCallback((animal) => {
    setEditingId(animal.id);
    const formData = {};
    
    // Map animal data to form fields
    const fieldMapping = {
      tag_number: 'tag_number',
      name: 'name',
      species: 'species',
      breed: 'breed',
      dob: 'dob',
      sex: 'sex',
      animal_class: 'animal_class',
      color: 'color',
      lifecycle_state: 'lifecycle_state'
    };

    Object.keys(fieldMapping).forEach(key => {
      let value = animal[fieldMapping[key]];
      if (value === null || value === undefined) {
        value = "";
      }
      // Format date if it exists
      if (value && typeof value === 'string' && value.includes('T')) {
        value = value.split('T')[0];
      }
      formData[key] = value;
    });
    
    formData.animal_type = animal.purchase_price ? "purchased" : "born";
    setForm(formData);
    setEditModalOpen(true);
  }, []);

  const closeEditModal = useCallback(() => {
    setEditModalOpen(false);
    setEditingId(null);
  }, []);

  // View Handler - Navigate to detail page
  const handleView = useCallback((animalId) => {
    navigate(`/animals/${animalId}`);
  }, [navigate]);

  // Virtualized Table Content - useCallback to prevent recreation
  const fixedHeaderContent = useCallback(() => (
    <TableRow>
      {columns.map((column) => (
        <TableCell
          key={column.dataKey}
          variant="head"
          align="left"
          style={{ width: column.width }}
          sx={{ 
            backgroundColor: colors.secondary, 
            color: 'black',
            fontWeight: 'bold',
            fontSize: '14px',
            padding: '12px 8px'
          }}
        >
          {column.dataKey !== 'actions' ? (
            <TableSortLabel
              active={sortConfig.key === column.dataKey}
              direction={sortConfig.key === column.dataKey ? sortConfig.direction : 'asc'}
              onClick={() => handleSort(column.dataKey)}
              sx={{ color: 'black !important' }}
            >
              {column.label}
            </TableSortLabel>
          ) : (
            column.label
          )}
        </TableCell>
      ))}
    </TableRow>
  ), [sortConfig, handleSort]);

  const rowContent = useCallback((index, animal) => (
    <React.Fragment>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" fontWeight="bold" noWrap>
          {animal.tag_number || 'N/A'}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {animal.name || 'N/A'}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {animal.species || 'N/A'}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {animal.breed || 'N/A'}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Chip 
          label={animal.animal_type === "purchased" ? "PURCHASED" : "BORN"} 
          size="small"
          sx={{ 
            fontSize: '0.7rem', 
            height: '24px',
            backgroundColor: animal.animal_type === "purchased" ? colors.primary : colors.secondary,
            color: 'white',
            fontWeight: 'bold'
          }}
        />
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {animal.age_string || 'N/A'}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {animal.sex || 'N/A'}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {animal.current_weight ? `${animal.current_weight} kg` : 'N/A'}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {animal.location || 'N/A'}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Chip 
          label="DRAFT" 
          size="small"
          sx={{ 
            fontSize: '0.7rem', 
            height: '24px', 
            fontWeight: 'bold',
            backgroundColor: colors.primary,
            color: 'white'
          }}
        />
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
          <IconButton 
            size="small" 
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              color: colors.primary 
            }}
            onClick={() => handleView(animal.id)}
            title="View Details"
          >
            <ViewIcon fontSize="small" />
          </IconButton>
          <IconButton 
            size="small" 
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              color: colors.secondary 
            }}
            onClick={() => openEditModal(animal)}
            title="Edit Animal"
          >
            <EditIcon fontSize="small" />
          </IconButton>
          <IconButton 
            size="small" 
            color="error"
            onClick={() => handleDelete(animal.id)}
            sx={{ minWidth: '32px', width: '32px', height: '32px' }}
            title="Delete Animal"
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
          <Button 
            size="small" 
            variant="contained" 
            sx={{ 
              minWidth: 'auto',
              px: 1,
              fontSize: '0.7rem',
              height: '32px',
              backgroundColor: colors.primary,
              color: 'white',
              '&:hover': {
                backgroundColor: colors.primaryDark,
              }
            }}
            onClick={() => handleSubmitForApproval(animal.id)}
            title="Submit for Approval"
          >
            Submit
          </Button>
        </Box>
      </TableCell>
    </React.Fragment>
  ), [handleView, openEditModal, handleDelete, handleSubmitForApproval]);

  return (
    <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
      {/* Header */}
      <AppBar position="static" elevation={2} sx={{ backgroundColor: colors.primary }}>
        <Toolbar>
          <PetsIcon sx={{ mr: 2, color: 'white' }} />
          <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold', color: 'white' }}>
            Onboarding Animal
          </Typography>
          <Chip 
            label={`${animals.length} Draft${animals.length !== 1 ? 's' : ''}`} 
            sx={{ 
              color: 'white', 
              fontWeight: 'bold', 
              mr: 2,
              backgroundColor: colors.secondary 
            }}
          />
          <Button 
            variant="contained" 
            startIcon={<AddIcon />}
            onClick={openAddModal}
            sx={{ 
              borderRadius: 2, 
              backgroundColor: colors.secondary,
              color: 'black',
              '&:hover': {
                backgroundColor: colors.secondaryDark,
              }
            }}
          >
            Add Animal
          </Button>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box sx={{ p: 3 }}>
        <Paper sx={{ mb: 3, borderRadius: 2, border: 2, borderColor: colors.secondaryLight }}>
          {/* Search and Filters */}
          <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  placeholder="Search draft animals by tag, name, breed..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                  <Button
                    startIcon={<FilterIcon />}
                    onClick={() => setShowFilters(!showFilters)}
                    variant={showFilters ? "contained" : "outlined"}
                    size="small"
                    sx={{
                      backgroundColor: showFilters ? colors.primary : 'transparent',
                      color: showFilters ? 'white' : colors.primary,
                      borderColor: colors.primary,
                      '&:hover': {
                        backgroundColor: colors.primaryLight,
                        color: 'white'
                      }
                    }}
                  >
                    Filters
                  </Button>
                  <Button 
                    onClick={resetFilters} 
                    variant="outlined" 
                    size="small" 
                    sx={{
                      color: colors.primary,
                      borderColor: colors.primary,
                      '&:hover': {
                        backgroundColor: colors.primaryLight,
                        color: 'white'
                      }
                    }}
                  >
                    Reset
                  </Button>
                </Box>
              </Grid>
            </Grid>

            {/* Expandable Filters */}
            {showFilters && (
              <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Species</InputLabel>
                      <Select
                        value={filters.species}
                        onChange={(e) => handleFilterChange('species', e.target.value)}
                        label="Species"
                      >
                        <MenuItem value="">All Species</MenuItem>
                        {options.species?.map(species => (
                          <MenuItem key={species} value={species}>{species}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Breed</InputLabel>
                      <Select
                        value={filters.breed}
                        onChange={(e) => handleFilterChange('breed', e.target.value)}
                        label="Breed"
                        disabled={!filters.species}
                      >
                        <MenuItem value="">All Breeds</MenuItem>
                        {options.breeds?.[filters.species]?.map(breed => (
                          <MenuItem key={breed} value={breed}>{breed}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Gender</InputLabel>
                      <Select
                        value={filters.sex}
                        onChange={(e) => handleFilterChange('sex', e.target.value)}
                        label="Gender"
                      >
                        <MenuItem value="">All Genders</MenuItem>
                        {options.sexes?.map(sex => (
                          <MenuItem key={sex} value={sex}>{sex}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Type</InputLabel>
                      <Select
                        value={filters.animal_type}
                        onChange={(e) => handleFilterChange('animal_type', e.target.value)}
                        label="Type"
                      >
                        <MenuItem value="">All Types</MenuItem>
                        <MenuItem value="born">Born</MenuItem>
                        <MenuItem value="purchased">Purchased</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Box>

          {/* Content Area */}
          <Box sx={{ p: 2 }}>
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                <CircularProgress sx={{ color: colors.primary }} />
                <Typography sx={{ ml: 2 }}>Loading draft animals...</Typography>
              </Box>
            ) : filteredAnimals.length === 0 ? (
              <Card sx={{ 
                textAlign: 'center', 
                p: 4, 
                border: 2, 
                borderColor: colors.secondaryLight,
                backgroundColor: colors.secondaryLight + '20'
              }}>
                <CardContent>
                  <PetsIcon sx={{ fontSize: 64, color: colors.primary, mb: 2 }} />
                  <Typography variant="h5" sx={{ color: colors.primary }} gutterBottom>
                    {animals.length === 0 ? "No draft animals found" : "No matching draft animals"}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                    {animals.length === 0 
                      ? "Create a new draft to get started with animal management" 
                      : "Try adjusting your search or filters to find what you're looking for"}
                  </Typography>
                  <Button 
                    variant="contained" 
                    sx={{ 
                      backgroundColor: colors.secondary,
                      color: 'black',
                      '&:hover': {
                        backgroundColor: colors.secondaryDark,
                      }
                    }} 
                    onClick={openAddModal} 
                    size="large"
                  >
                   Onboarding Animal
                  </Button>
                </CardContent>
              </Card>
            ) : (
              <Paper elevation={0} sx={{ 
                height: 600, 
                border: 1, 
                borderColor: colors.secondaryLight, 
                borderRadius: 1 
              }}>
                <TableVirtuoso
                  data={filteredAnimals}
                  components={VirtuosoTableComponents}
                  fixedHeaderContent={fixedHeaderContent}
                  itemContent={rowContent}
                />
              </Paper>
            )}
          </Box>
        </Paper>
      </Box>

      {/* Add FAB for mobile */}
      <Fab
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          display: { xs: 'flex', md: 'none' },
          backgroundColor: colors.secondary,
          color: 'black',
          '&:hover': {
            backgroundColor: colors.secondaryDark,
          }
        }}
        onClick={openAddModal}
      >
        <AddIcon />
      </Fab>

      {/* Add Animal Modal */}
      <Dialog 
        open={addModalOpen} 
        onClose={closeAddModal}
        maxWidth="md"
        fullWidth
        PaperProps={{ 
          sx: { 
            borderRadius: 2,
            minHeight: '600px'
          } 
        }}
      >
        <DialogTitle sx={{ 
          backgroundColor: colors.primary, 
          color: 'white',
          borderBottom: 1,
          borderColor: 'divider'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h5" fontWeight="bold">
              Onboarding New Animal 
            </Typography>
            <IconButton onClick={closeAddModal} size="small" sx={{ color: 'white' }}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
            Fill in the basic information to onboard an animal. You can complete the rest of the details on the animal's detail page.
          </Typography>
          <BasicInfoForm 
            form={form}
            onFormChange={handleFormChange}
            options={options}
            isEdit={false}
          />
        </DialogContent>
        <DialogActions sx={{ p: 3, gap: 1, borderTop: 1, borderColor: 'divider' }}>
          <Button 
            onClick={closeAddModal} 
            variant="outlined" 
            sx={{
              color: colors.primary,
              borderColor: colors.primary,
              '&:hover': {
                backgroundColor: colors.primaryLight,
                color: 'white'
              },
              minWidth: 100
            }}
          >
            Cancel
          </Button>
          <Button 
            variant="contained" 
            sx={{
              backgroundColor: colors.secondary,
              color: 'black',
              '&:hover': {
                backgroundColor: colors.secondaryDark,
              },
              minWidth: 200
            }}
            onClick={handleCreateDraft}
            disabled={!form.tag_number || !form.breed || !form.dob || !form.sex}
          >
            Create Draft & Continue
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Animal Modal */}
      <Dialog 
        open={editModalOpen} 
        onClose={closeEditModal}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2 } }}
      >
        <DialogTitle sx={{ backgroundColor: colors.primary, color: 'white' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h5" fontWeight="bold">
              Edit Draft Information
            </Typography>
            <IconButton onClick={closeEditModal} size="small" sx={{ color: 'white' }}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 3, mt: 2 }}>
            Update the basic information for this draft animal.
          </Typography>
          <BasicInfoForm 
            form={form}
            onFormChange={handleFormChange}
            options={options}
            isEdit={true}
          />
        </DialogContent>
        <DialogActions sx={{ p: 3, gap: 1 }}>
          <Button 
            onClick={closeEditModal} 
            variant="outlined" 
            sx={{
              color: colors.primary,
              borderColor: colors.primary,
              '&:hover': {
                backgroundColor: colors.primaryLight,
                color: 'white'
              }
            }}
          >
            Cancel
          </Button>
          <Button 
            variant="contained" 
            sx={{
              backgroundColor: colors.secondary,
              color: 'black',
              '&:hover': {
                backgroundColor: colors.secondaryDark,
              },
              minWidth: 140
            }}
            onClick={handleUpdateBasicInfo}
            disabled={!form.tag_number || !form.breed || !form.dob || !form.sex}
          >
            Update Draft
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default DraftAnimalsPage;